<template>
  <div class="home">
    <!-- muted -->
<!--    <div class="videoTest" v-if="showVideo">

    </div>-->

<!--    x-webkit-airplay="allow"
    x5-video-player-type="h5"
    x5-video-player-fullscreen="true"
    x5-video-orientation="portraint"-->
    <div
      v-show="showPoster"
      class="main-video poster-image"
      :style="{
        backgroundImage: `url(${videoUrl}?x-oss-process=video/snapshot,t_1,m_fast,f_jpg)`,
        backgroundRepeat: 'no-repeat',
        'z-index': posterIndex
      }"
      @click.self="videoClick('poster')"
    />

    <video
      ref="myVideo"
      preload="auto"
      class="main-video talkingVideo"
      id="main-video"
      muted
      loop
      :autoplay="false"
      playsinline="true"
      webkit-playsinline="true"
      x5-playsinline="true"
      :controls="false"
      :src="videoUrl"
      :poster="videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast,f_png'"
      @pause="onPauseVideo(0)"
      @play="
        (a, b) => {
        sConsole('video on play', 'playing in ' + new Date(), a, b);
        // this.showPoster = false
        if(!firstPlayed) {
          posterIndex = -9
        }
      }"
      @click.self="videoClick('video')"
      v-show="!isTakingEnd"
    /> <!--&& priorityLock-->

    <!-- 双视频 闭嘴视频 showTalkVideo -->
    <video
      ref="myVideo1"
      preload="auto"
      class="main-video sliceVideo"
      id="main-video1"
      muted
      loop
      :autoplay="false"
      playsinline="true"
      webkit-playsinline
      x5-playsinline
      :controls="false"
      :src="videoUrlSlice"
      :poster="videoUrlSlice + '?x-oss-process=video/snapshot,t_1,m_fast,f_png'"
      @pause="onPauseVideo(1)"
      @play="
          (a, b) => {
          //sConsole('video', 'video1 playing in ' + new Date(), a, b);
          isVideo1Pause = false;
          showPoster = false;
          }"
      @click.self="videoClick('video')"
      v-show="isTakingEnd"
    >
    </video>
    <!--    !firstPlayed || (!isTakingEnd && !showPoster)-->

    <!--    测试方形视频-->
    <!--    <video
          ref="myVideo"
          preload="auto"
          class="main-video-fang talkingVideo"
          id="main-video"
          muted
          loop
          :autoplay="false"
          playsinline="true"
          webkit-playsinline="true"
          x5-playsinline="true"
          :controls="false"
          :src="videoUrlFang"
          :poster="videoUrlFang + '?x-oss-process=video/snapshot,t_1,m_fast,f_png'"
          @pause="onPauseVideo(0)"
          @play="
            (a, b) => {
            sConsole('video on play', 'playing in ' + new Date(), a, b);
            // this.showPoster = false
            if(!firstPlayed) {
              posterIndex = -1
            }
          }"
          @click.self="videoClick('video')"
          v-show="!isTakingEnd"
        />-->

    <!--    测试方形视频-->
<!--    <video
      ref="myVideo1"
      preload="auto"
      class="main-video-fang sliceVideo"
      id="main-video1"
      muted
      loop
      :autoplay="false"
      playsinline="true"
      webkit-playsinline
      x5-playsinline
      :controls="false"
      :src="videoUrlFang"
      :poster="videoUrlFang + '?x-oss-process=video/snapshot,t_1,m_fast,f_png'"
      @pause="onPauseVideo(1)"
      @play="
          (a, b) => {
          //sConsole('video', 'video1 playing in ' + new Date(), a, b);
          isVideo1Pause = false;
          showPoster = false;
          }"
      @click.self="videoClick('video')"
      v-show="isTakingEnd"
    >
    </video>-->

    <audio
      v-for="(item, index) in audioInitPool"
      :key = 'index'
      :id="'main-audio' + index"
      class="main-audio"
      :ref="'myAudio' + index"
      controls
      x-webkit-airplay="allow"
      x5-audio-player-type="h5"
      x5-audio-player-fullscreen="true"
      x5-audio-orientation="portraint"
      preload="auto"
      :src="originAudioUrl"
      @loadedmetadata="(a, b) => {
        // sConsole('audio' + index, 'loadedmetadata'+ readTime(), a, b);
        audioLoadedmetadata(index);
      }"

      @canplaythrough="(a, b) => {
        // sConsole('audio' + index, 'canplaythrough'+ readTime(), a, b);
        // src不改，canplay和canplaythrough都是会触发的，因为有旧的，放这里的话，一点发送就播放旧的
        onCanplayAudio(index)
      }"

      @ended="(a, b) => {
        sConsole('audio' + index, ' ended', a, b);

      }"

      @webkitended="(a, b) => {
        sConsole('audio' + index, ' webkitended', a, b);

      }"
    >
      <!--
      @pause="
      (a, b) => {
      sConsole('audio' + index, 'pause', a, b);
      onAudioEndedSelf('pause', index);
      }
      "
      @ended="(a, b) => {
        sConsole('audio' + index, 'ended', a, b);
        onAudioEndedSelf('ended', index);
      }"

      @error="
      (a, b) => {
      sConsole('audio' + index, 'error', a, b);
      audioError('error', index);
      }
      "
      @abort="
      (a, b) => {
      sConsole('audio' + index, 'abort', a, b);
      audioAbort('abort', index);
      }
      "

      @loadstart="(a, b) => sConsole('audio' + index, 'loadstart:' + new Date().getTime(), a, b)"
      @progress="(a, b) => sConsole('audio' + index, 'progress' + new Date().getTime(), a, b)"

      @loadeddata="
      (a, b) => {
      sConsole('audio' + index, 'loadeddata'+ new Date().getTime(), a, b);
      audioPlay(); // noah modify 会触发 audioPlayFn() 导致video提前
      }
      "
      @play="
      (a, b) => {
      sConsole('audio' + index, 'play'+ new Date().getTime(), a, b);
      }
      "

      @durationchange="(a, b) => sConsole('audio' + index, 'durationchange', a, b)"
      @canplay="(a, b) => {
      sConsole('audio' + index, 'canplay', a, b)
      }"
      @playing="
      (a, b) => {
      sConsole('audio' + index, 'playing', a, b);
      onAudioPlaying(index)
      }
      "
        -->
      <!-- 预设一个 src 防止第一次没文件播放时报错 -->
    </audio>

    <!--底部信息展示区域-->
    <div class="bottom-tool-container" id="bottom-tool-container" ref="bottom-tool-container">
      <div class="bottom-tool-main">
        <!-- <div
          v-if="sendMsgLoading"
          class="cover-container hx-flex-c-c"
          style="padding-bottom: 0"
        >
          <div
            class="hx-flex-c-c container-item"
            style="display: inline-block; padding: 0; font-size: 0"
          >
            <img
              class="loading-gif"
              :src="require('/src/assets/icon/jz.gif')"
              alt=""
              srcset=""
            />
          </div>
        </div> -->
        <div class="cover-container hx-flex-c-c hx-flex-a-e">
          <!-- <div style="flex: 1"> -->
          <!-- <RecordingAnimation ref="RecordingAnimation"></RecordingAnimation> -->
          <RobotReplyContainer ref="RobotReplyContainer" v-show="!showPanel"></RobotReplyContainer>


          <ProductList
            ref="ProductList"
            :sendMsgLoading="sendMsgLoading"
            :firstPlayed="firstPlayed"
            @showProductDialog="showProductDialog"
            @onShopUrl="onShopUrl"
            @jumpMiniProgram="jumpMiniProgram"
            @onClickFirstProduct="onClickFirstProduct"
            @onCommodityClick="onCommodityClick"
            v-show="!showPanel"
          ></ProductList>
        </div>
        <div id="show-more-product-list-popup"></div>
        <InputTool ref="InputTool" @playVideo="playVideo" @onBaiduASR="onBaiduASR"
                   @onClickShoppingCar="onClickShoppingCar" @onClickShopChoose="onClickShopChoose" :user_token="user_token"></InputTool>
      </div>
    </div>

    <TopToolBar ref="myTopToolBar" @changePanelShow="changePanelShow" @wantClick="wantClick" @testStopTimer="testStopTimer"
                @jumpMiniProgram="jumpMiniProgram"></TopToolBar>
    <LinkInfoCard ref="myLinkInfoCard" @liuyanShow="liuyanShow" @qunLiaoShow="qunLiaoShow" @changePhoneShow="changePhoneShow"></LinkInfoCard>
    <CardBar ref="myCardBar" @toggleContent="toggleContent" :isShowContent="showContent" v-if="cardShow"></CardBar>
    <CardBarContent ref="myCardBarContent" v-if="cardShow && showContent"></CardBarContent>
    <img class="abs_myself" :src="icon_myself" @click="clickMyself" v-if="false"/>
    <img class="abs_company" :src="icon_company" @click="clickCompany" v-if="false"/>
    <div class="abs_company_text">
      {{ company_name }}
    </div>
    <div class="abs_zhiwei_text">
      {{ title }}
    </div>
    <div class="abs_tiktok" @touchmove="handleTiktokTouchMove" @click="handleTiktok">
      <img width="50" height="335" :src="icon_turn_right"/>
    </div>

    <van-popup v-model="showPanel" position="top" class="my_user_info_popup">
      <UserCard ref="userInfoCard" v-show="showPanel" @liuyanShow="liuyanShow" @qunLiaoShow="qunLiaoShow" @closeUserCard="closeUserCard"></UserCard>
    </van-popup>

    <CareDialog ref="careDialog" v-if="showCareDialog" :showCareDialog="showCareDialog" @onShowCareDialog="onShowCareDialog" @closeCareDialog="closeCareDialog"
                @onclickCare="onclickCare"></CareDialog>
    <!--产品播放全屏弹窗 mediaDialog-->
    <ProductDialog ref="myProductDialog" v-if="mediaDialog" :productItem="productItem" :adviceClickEnd="adviceClickEnd"
                   @onCloseMediaDialog="onCloseMediaDialog"
                   @productVideoClick="productVideoClick"
                   @promptMessage="promptMessage"
                   @adviceClick="adviceClick"/>
    <!--商城H5 iframe显示 暂时没有-->
    <ShopIframe class="shop_iframe" :frameSrc="frameSrc" v-if="openShop"/>

    <!--新版底部弹出联系电话-->
    <van-action-sheet
        v-model="phoneShow"
        :actions="actions"
        cancel-text="取消"
        :description="phone"
        close-on-click-action
        @select="onSelect"
        :overlay="true"
    />

    <!--右侧左滑进入视频展示-->
    <van-popup v-model="showTiktok" position="right" :overlay="true" overlay-class="tiktokPage"
               :close-on-click-overlay="false" :lock-scroll="true">
      <TiktokPage @closeTikTok="closeTikTok"/>
    </van-popup>

<!--    全局跳转小程序登录弹框 您需要登录小程序以获得更好的体验-->
    <van-dialog v-model="$store.state.loginMiniDialog" title="登录-小程序" :message="$store.state.jumpLoginMessage" showCancelButton
                confirmButtonText="登录" cancelButtonText="取消" @confirm="confirmLoginMiniDialog" @cancel="cancelLoginMiniDialog"
    />

  </div>
</template>

<script>
import Vue, { ref } from 'vue'
// import dayjs from "dayjs";
import TopToolBar from "./components/TopToolBar.vue";
import LinkInfoCard from "./components/LinkInfoCard.vue";
import CardBar from "./components/CardBar.vue";
import CardBarContent from "./components/CardBarContent.vue";
import InputTool from "./components/InputTool.vue";
import RobotReplyContainer from "./components/RobotReplyContainer.vue";
import UserCard from "./components/UserCard.vue";
import CareDialog from "./components/CareDialog.vue";
import ProductList from "./components/ProductList.vue";
import ShopIframe from "./components/ShopIframe.vue";
import enableInlineVideo from "iphone-inline-video";
import { baiduASRApi } from "@/api/baiduASR";
import {
  aLiYunTTSUrl,
  aLiYunTTSUrl_axios_promise, clearRequestArray, logRequestArray,
  getAliYunTTSToken, shiftOriginList, requestMiniMaxTts, controllerAbort2
} from '@/api/aLiYunTTS'
import { askApiStream, askApiStreamAgent, clearAllStr, controllerAbort } from '@/api/askApiStream'
import AudioEnter from '@/views/home/components/AudioEnter.vue'
import ProductDialog from '@/views/home/components/ProductDialog.vue'
import { url_to_query } from '@/plugins/getUrlParam'
import generateUserName from '@/utils/generateUserName'
import TiktokPage from '@/views/home/components/TiktokPage.vue'
import { formatTime, readTime } from '@/utils/timerUtil'
import timerUtil from '@/utils/timerUtil'
import { APPLET_Id, isDt, MEDIA_SHOW } from '@/api/constants'
import { getTtsInfo } from '@/api/app'
import index from 'vuex'
import { Dialog, Actionsheet  } from 'vant'
import store from '@/store'
/* import * as string_decoder from 'string_decoder'
import $store from '@/store'
import { new_int } from 'lamejs/src/js/common'
//import { error } from '@babel/eslint-parser/lib/convert'
import {Howl, Howler} from 'howler';
// import RecordingAnimation from "./components/RecordingAnimation.vue";
// import { askApi } from "@/api/app";
*/


export default {
  name: "Home",
  components: {
    TiktokPage,
    AudioEnter,
    TopToolBar,
    LinkInfoCard,
    CardBar,
    CardBarContent,
    InputTool,
    RobotReplyContainer,
    UserCard,
    CareDialog,
    ProductList,
    ProductDialog,
    ShopIframe
    // RecordingAnimation,
  },
  props: {},
  data() {
    return {
      posterIndex: 1,
      isAudioPlaying: false,
      sendMsgLoading: false,
      preUrl: window.location.href.split(window.location.hash)[0],
      // videoUrl: "",
      // audioUrl: "",
      firstPlayed: false,
      firstPlayEnd: false, // 第一句话播放是否完成
      showPoster: true,
      TTSList: [],
      currentTTSText: '',
      timeOutClearASRShowTimer: null,
      showVideo: false,
      answerIndex: 0,
      playAudioIndex: 0,
      testAudioList:[],
      isiOS: false,
      isWeiXin: false,
      isFirstAudioCanPlay: false,
      isFirstVideoCanPlay: false,
      currAudio: null,// 当前的音频 仅针对非ios
      audioInitPool: [0,1,2,3,4], // 点击你好后的声音
      audioPoolMax: 5, // 点击你好后的声音
      audioPlayPool: [], // 点击你好后的声音
      originAudioList: [], // 初始audio，用以videoClick暂停恢复状态
      refreshAliTtsTokenTimer: null,
      isVideo1Pause: false,
      showTalkVideo: true,
      isTakingEnd: false, // 搭配showTalkVideo 语音回答的间隔
      beautyTalk: '', // 新春祝福第一句话
      globalClickCount: 0,
      onceAlertCount: [false, false, false], // 群二维码弹窗 留言弹窗 关注弹窗
      chatCount: 0, // 交互次数或对话次数
      productClickCount: 0,
      productCloseCount: 0,
      showCareLoveShowEnd: false, // 是否展示过关注弹窗
      showLiuYanEnd: false, // 是否展示过留言弹窗
      mediaDialog: false,
      productItem: {
        name: '',
        price: '',
        url: ''
      },
      adviceClickEnd: true,// 是否咨询按钮点击播放完成，默认完成
      // 页面关键词和描述内容
      description: '打造个人AI智能体，用AI技术赋予品牌新生命，让你对用户的服务随时都在，让你成为品牌AI智能体。',
      keywords: 'AI智能体',
      // 处理小程序的参数
      user_token: '',
      is_new: '1',
      // isCare: false, 改到appletInfo中
      visit_user_name: '',
      visitInfo: [], // visit_user_name: "egllczlc", visit_number: 352, chatCount: 0, // 交互次数或对话次数
      helloBtnClick: false,
      needPrompt: false,
      markThree: false,
      promptTimer: null,
      currentQuestion: '',
      // 废话文学
      priorityLock: false,// 声音优先级级锁
      howlAudio: null,
      checkInterval: null,
      // 新版本UI优化
      showPanel: false,
      showCareDialog: false,
      icon_myself: require('@/assets/icon/icon_myself.png'),
      icon_company: require('@/assets/icon/icon_company.png'),
      // icon_double_right: require('@/assets/icon/icon_round_right.png'),
      icon_turn_right: require('@/assets/img_turn_right.png'),
      showContent: false,
      actions: [{ name: "呼叫" }],
      phoneShow: false,
      // 流式打招呼
      greetText: '',
      // 测试检索类名
      testName: '测试混音 ',
      timeCountTag: 'timeCount',
      timeCountFlag: true,
      timeCountABS: 0,
      // 商城
      openShop: false,
      frameSrc: 'https://h5.meuagi.com',
      showTiktok: false,
      testCount: 0,
      logName: '测试混音新Tag',
      // 新tts合成方法
      originAudioUrl: '',
      textList: [],
      requestIndex: -1,
      requestList: [],
      videoUrlFang: require('./../../assets/fang.mp4') // 'https://awu-file.oss-cn-guangzhou.aliyuncs.com/applet/11%E6%9C%8812%E6%97%A5.mp4'// require(./../../assets/fang.mp4)
      // 小程序未登录浏览H5 需要跳转登录界面的方案
      // loginMiniDialog: this.$store.state.loginMiniDialog
    }
  },
  computed: {
    index () {
      return index
    },
    videoUrl() {
      return this.$store.state?.vuex_app_video_info?.talk_url || ''
    },
    videoUrlSlice() {
      return this.$store.state?.vuex_app_video_info?.silence_url || ''
    },
    cardShow() {
      return false // typeof this.$store.state?.vuex_cardInfo?.title !== 'undefined';
    },
    phone() {
      // return this.$store.state?.vuex_app_user_info?.phone || "";
      if (this.$store.state?.vuex_app_user_info?.mobile_num){
        return this.$store.state?.vuex_app_user_info?.mobile_num
      } else {
        return this.$store.state?.vuex_app_user_info?.phone || '';
      }
    },
    title() {
      return this.vuex_app_user_info?.title || ''
    },
    company_name() {
      return this.vuex_app_user_info?.company_name || ''
    },
    biography() {
      return this.vuex_app_user_info?.biography
    },
    /* originAudioUrl() {
      // if (this.$store.state.weiXinMark && this.TTSList.length > 1){
      const text = this.$store.state?.vuex_app_user_info?.biography || "你好"; // 不要为空，会报错
      this.currentTTSText = text;
      return aLiYunTTSUrl(text);
    } */
  },
  watch: {
    /* showTalkVideo(newValue) {
      console.log('showTalkVideo changed:', newValue)
    }, */
    /* biography(newValue) {
      console.log('biography changed:', newValue)
    }, */
    playAudioIndex(newValue) {
      console.log('playAudioIndex changed:', newValue)
    },
    requestList(newValue) {
      // console.log('requestList changed:', newValue)
    },

  },
  created() {
    Vue.prototype.$_sendMsgAnswerShowAndPlayEvent =
      this.sendMsgAnswerShowAndPlayEvent;
    Vue.prototype.$_sendMsgAnswerShowAndPlayEventGreet =
      this.sendMsgAnswerShowAndPlayEventGreet;
    Vue.prototype.$_ttsTokenInitOk = this.ttsTokenInitOk;
    Vue.prototype.$userInfoInit = this.userInfoInit
  },
  mounted() {
    console.log('cctest', decodeURIComponent('%7Biy%3Aw%2F33H0LSmtWlcOoxDhKd6iC7j%20JgCiDDxZGLR9d%20lsQ%3D,env%3At%7D'))
    window.addEventListener('message', this.getPostMessage) // postMessage 全局监听
    const audio = document.getElementById("main-audio");
    document.addEventListener(
      "WeixinJSBridgeReady",
      function () {
        console.log('WeixinJSBridgeReady')
        audio?.play?.();
      },
      false
    );
    document.addEventListener(
      "YixinJSBridgeReady",
      function () {
        console.log('YixinJSBridgeReady')
        audio?.play?.();
      },
      false
    );
    document.addEventListener("visibilitychange", ()=> {
      if (document.visibilityState === 'visible') {
        // 页面重新可见，重新播放视频
        console.log('页面重新可见', this.isVideo1Pause)
        if(this.isVideo1Pause && this.firstPlayed){
          const video1 = this.$refs.myVideo1
          if(video1 !== null && typeof video1 !== 'undefined'){
            video1.play()
          }
        }
      } else {
        console.log('页面不可见')
        // 尝试停止所有声音 当语音结束 和 第一次点击界面后
        if(this.firstPlayed){ // !this.isTakingEnd &&
          this.videoClick('stopVideo')
          this.cancelPromptTimer()
        }
      }
    });

    // this.docReady()

    // 处理微信字体大小被放大的问题
    if(typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge.invoke === 'function'){
      console.log('noah font size handleFontSize  WeixinJSBridge === object')
      this.handleFontSize();
    } else if(document.addEventListener){
      console.log('noah font size handleFontSize addEventListener')
      document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false);
    } else if(document.attachEvent){
      console.log('noah font size handleFontSize attachEvent')
      document.attachEvent('WeixinJSBridgeReady', this.handleFontSize);
      document.attachEvent('onWeixinJSBridgeReady', this.handleFontSize);
    }


    // 监听全局的点击事件
    document.addEventListener('click', this.clickCounter);

    this.isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    console.log('isiOS:' + this.isiOS)
    let userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('miniprogram') !== -1) {
      this.$store.commit('updateMiniProgramMark', true)
    } else {
      this.$store.commit('updateMiniProgramMark', false)
    }
    this.initWxMedia(audio)


    this.showVideo = true
    const video = document.querySelector("video");
    enableInlineVideo(video); // noah modify

    // ios 上不能触发audio加载完成监听
    if (!this.isiOS){
      this.changeSendMsgLoading(true);
      this.$refs?.InputTool?.setDisabledBtn(true)

    }

    // 处理url参数
    this.detailUrl()
    this.testMethod()
    this.$store.commit('updateVisit', 1)
    console.log('访问次数 visitList length:', this.$store.state.visitList.length)

    // 每隔三分钟刷新阿里云语音合成的token 目的是降低移动端长时间息屏后获取语音token过期的问题
    this.refreshAliTtsTokenTimer = setInterval(async ()=>{
      try {
        const ttsTokenRes = await getAliYunTTSToken()
        const token = ttsTokenRes?.data?.token || ''
        this.$vuex('vuex_aliyun_tts_token', token)
        console.warn(
          '🚀 ~ refresh vuex_aliyun_tts_token : ',
          this.vuex_aliyun_tts_token
        )
      }
      catch (error) {
        console.error(
          '🚀 ~ file: initToken.mixin.js:95 ~ initAppToken ~ error : ',
          error
        )
        this.$myToast({
          type: 'fail',
          message: '获取TTS Token错误'
        })
      }
    }, 10 * 60 * 1000);


  },
  beforeDestroy() {
    window.removeEventListener('message', this.getPostMessage, false)
    // 移除事件监听器
    window.removeEventListener('online', this.handleOnlineStatus);
    window.removeEventListener('offline', this.handleOfflineStatus);

    this.clearTimeOutClearASRShowTimer()
    if (this.refreshAliTtsTokenTimer != null){
      clearInterval(this.refreshAliTtsTokenTimer)
      this.refreshAliTtsTokenTimer = null
    }

    if (this.promptTimer){
      clearTimeout(this.promptTimer)
    }
    // 在组件销毁前移除事件监听
    document.removeEventListener('click', this.clickCounter);
  },
  provide() {
    return {
      stopAllMedia: this.stopAllMedia,
      getMyVideo: this.getMyVideo,
      getMyAudio: this.getMyAudio,
      playVideo: this.playVideo,
      playAudio: this.playAudio,
      baiduASR: this.baiduASR,
      sendMsg: this.sendMsg,
      sendMsgAnswerShowAndPlayEvent: this.sendMsgAnswerShowAndPlayEvent,
      sendMsgAnswerShowAndPlayEventGreet: this.sendMsgAnswerShowAndPlayEventGreet,
      firstPlayAllMedia: this.firstPlayAllMedia,
      changeASRShow: this.changeASRShow,
      changeASRText: this.changeASRText,
      clearTTSList: this.clearTTSList,
      clearProductReading: this.clearProductReading,
      clickTestBtn: this.btnTestClick,
      clearAudioList: this.clearAudioList
    };
  },
  methods: {
    userInfoInit(data) {
      document.title = process.env.VUE_APP_TITLE // 防止进入子页面不更新标题
      if (this.$store.state?.vuex_app_user_info?.biography !== ''){
        this.description = this.$store.state?.vuex_app_user_info?.biography
      }
      if (this.$store.state?.vuex_app_user_info?.company_name !== ''){
        this.keywords = this.keywords + ',' + this.$store.state?.vuex_app_user_info?.company_name
      }
      if (this.$store.state?.vuex_app_user_info?.nickname !== ''){
        this.keywords = this.keywords + ',' + this.$store.state?.vuex_app_user_info?.nickname
      }
      if (this.$store.state?.vuex_app_user_info?.title !== ''){
        this.keywords = this.keywords + ',' + this.$store.state?.vuex_app_user_info?.title
      }
      if (this.$store.state?.vuex_app_user_info?.tags?.length > 0) {
        this.$store.state?.vuex_app_user_info?.tags.forEach(t => {
          this.keywords = this.keywords + ',' + t
        })
      }
      // 小南老师的特殊处理
      if (this.$store.state?.vuex_app_user_info?.mobile_num === '13902459693' || this.$store.state?.vuex_app_user_info?.mobile_num === '13902459693'){
        this.keywords = 'AI商业思维,AI销售智能体,人工智能专家,小南老师'
        this.description = '会销售的AI智能体,人工智能体专家,小南老师'
      }
      document.head.querySelector('meta[name="keywords"]').setAttribute('content', this.keywords)
      document.head.querySelector('meta[name="description"]').setAttribute('content', this.description)
      let wxShareInfo = {
        nickname: this.$store.state.vuex_app_user_info.nickname,
        title: this.$store.state.vuex_app_user_info.title,
        company_name: this.$store.state.vuex_app_user_info.company_name,
        phone: this.$store.state.vuex_app_user_info.phone,
        wechat_link_url: this.$store.state.vuex_app_user_info.wechat_link_url
      }
      // 在Webview中发送消息给小程序原生页面
      wx.miniProgram.postMessage({ data: wxShareInfo })

      // 初始化新版Tts信息
      this.initMimiMaxTtsToken()
    },
    handleFontSize(){
      console.log('noah font size handleFontSize')
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on('menu:setfont', function(){
        WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
      });
    },
    ttsTokenInitOk(){
      console.log('ttsToken 鉴权初始化完成')
    },
    testMethod() {
     /*  console.log('enter method')
      const str_1 = "第一句：蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。蝴蝶翩翩舞飞扬，
      蜜蜂采蜜忙不停。蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。" +
        "蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。蝴蝶翩翩舞飞扬，蜜蜂采蜜忙不停。"
      const str_2 = "第二句：翠绿嫩叶轻摇曳，小鸟啼鸣声声响。"
      const url = await aLiYunTTSUrl_axios_promise(str_1) // 音频接口新 合成接口
      console.log('miniMax url:',url)
      this.playAudioAndroidNewManyAudio(url, str_1, false)

      const url2 = await aLiYunTTSUrl_axios_promise(str_2) // 音频接口新 合成接口
      console.log('miniMax url2:', url2)
      this.playAudioAndroidNewManyAudio(url2, str_2, false)

      let nextAudio = eval('this.$refs.myAudio' + 0)[0] || eval('this.$refs.myAudio' + 0);
      nextAudio.src = url
      nextAudio.play() */
      //微信公众号获取用户信息 原文链接：https://blog.csdn.net/u013302168/article/details/139896204

    },
    async initMimiMaxTtsToken () {
      let text = this.$store.state?.vuex_app_user_info?.biography || '你好' // 不要为空，会报错
      this.currentTTSText = text

      try {
        // 获取新版tts的鉴权信息
        getTtsInfo().then( async res => {
          const ttsInfo = res?.data || {
            accessToken: '',
            group_id: ''
          }
          console.warn('🚀 ~ file: initToken.mixin.js:67 ~ initAppToken ~ getTtsInfo : ', ttsInfo)
          this.$vuex('ttsInfo', ttsInfo)
          // this.originAudioUrl = await aLiYunTTSUrl(text)//
          // this.originAudioUrl  = await aLiYunTTSUrl_axios_promise(text)// aLiYunTTSUrl
          // 按照句子进行拆分短句进行合成 超过2句话以上的 requestMiniMaxTts
          let isChines = true
          let textList = []
          const chinesePeriod = /。/g;
          const englishPeriod = /\./g;

          // 统计中文句号和英文句号在字符串中出现的次数
          const chineseCount = (text.match(chinesePeriod) || []).length;
          const englishCount = (text.match(englishPeriod) || []).length;

          // 判断中文句号和英文句号出现的次数，返回结果
          if (chineseCount > 0 && englishCount === 0) {
            isChines = true
          } else if (englishCount > 0 && chineseCount === 0) {
            isChines = false
          } else {
            if(englishCount > chineseCount){
              isChines = false
            }
          }

          if (isChines){
            textList = text.split('。')
          } else {
            textList = text.split('.')
          }
          if(textList.length > 0){
            // console.log('textList', textList)
            let loopIndex = 0
            let firstText = textList[0]
            let nextAudio = this.$refs.myAudio0[0]
            nextAudio.addEventListener('ended', this.onFirstAudioEnded)
            nextAudio.addEventListener('playing', this.onAudioPlayingListenEvent)
            requestMiniMaxTts(firstText, 0,{speed: 1.0}, false).then(requestList => {
              this.requestList = requestList
              if(this.requestList.length > 0) {
                if(this.requestList[0].url !== ''){
                  this.originAudioUrl = this.requestList[0].url
                  nextAudio.text = this.requestList[0].text
                  // 关闭遮罩
                  this.$myToast?.clear?.()
                }
              }
            })
            .catch((error) => {
              console.log('requestMiniMaxTts biography error:', error)
              if(error?.data){
                // 关闭遮罩
                this.$myToast?.clear?.()
                Dialog.alert({
                  title: '语音合成失败',
                  message: '将使用默认声音，请在APP重新选择智能体声音'
                }).then(() => {
                  // on close
                  const userInfo = store.state.vuex_app_user_info
                  if( userInfo.gender === 'male'){
                    userInfo.voice_id = 'male-qn-qingse'
                  } else {
                    userInfo.voice_id = 'female-shaonv'
                  }
                  this.$vuex('vuex_app_user_info', userInfo)
                });
              }
            })
            const loopWithDelay = ()=>{
              loopIndex = loopIndex + 1
              if(loopIndex < textList.length){
                let currText = textList[loopIndex].replace(/\s/g, '')
                setTimeout(()=>{
                  if(currText !== ''){
                    //console.log('requestMiniMaxTts text', loopIndex, currText)
                    requestMiniMaxTts(currText, loopIndex, {speed: 1.0}, false).then(requestList => {
                      this.requestList = requestList
                      // console.log('this.requestList', this.requestList)
                    }).catch((error) => {
                      console.log('requestMiniMaxTts loop error:', error)
                      if(error?.data){
                        // 关闭遮罩
                        this.$myToast?.clear?.()
                        Dialog.alert({
                          title: '语音合成失败',
                          message: '将使用默认声音，请在APP重新选择智能体声音'
                        }).then(() => {
                          // on close
                          const userInfo = store.state.vuex_app_user_info
                          if( userInfo.gender === 'male'){
                            userInfo.voice_id = 'male-qn-qingse'
                          } else {
                            userInfo.voice_id = 'female-shaonv'
                          }
                          this.$vuex('vuex_app_user_info', userInfo)
                        });
                      }
                    })
                    loopWithDelay()
                  } else {
                    textList.splice(loopIndex, 1)
                    loopIndex = loopIndex - 1 // 避免中间是空字符串的
                    loopWithDelay()
                  }
                }, 300)
              }
            }
            loopWithDelay()

          }


          // console.log('biography originAudioUrl tts url:', this.originAudioUrl)
          // 关闭遮罩
          // this.$myToast?.clear?.()
        }).then(error =>{
          console.error('🚀 ~ file: initToken.mixin.js:52 ~ getTtsInfo ~ error : ', error)
        })
      } catch (error) {
        console.error('Error fetching audio URL:', error);
      }
    },
    hexToAudio(hexString, sampleRate) {
      // 将16进制字符串转换为原始数据
      var rawData = new Uint8Array(hexString.match(/.{2}/g).map(function (hexVal) {
        return parseInt(hexVal, 16);
      }));
    },

    async docReady() {
      var ua = navigator.userAgent.toLowerCase()
      var isWXWork = ua.match(/wxwork/i) === 'wxwork'
      var isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
      let isMobile = false
      let isDesktop = false
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
        isMobile = true
      } else {
        isDesktop = true
      }

      if (isWeixin) {
        console.log('打开小程序：isWeixin： true')
        var launchBtn = document.getElementById('launch-btn')
        launchBtn.addEventListener('ready', function (e) {
          console.log('开放标签 ready')
        })
        launchBtn.addEventListener('launch', function (e) {
          console.log('开放标签 success')
        })
        launchBtn.addEventListener('error', function (e) {
          console.log('开放标签 fail', e.detail)
        })

        wx.config({
          // debug: true, // 调试时可开启
          appId: 'wx264f4850dc92b03d', // <!-- replace -->
          timestamp: 0, // 必填，填任意数字即可
          nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
          signature: 'signature', // 必填，填任意非空字符串即可
          jsApiList: ['onMenuShareAppMessage','startRecord', 'stopRecord'], // 必填，随意一个接口即可
          openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
        })
      } else if (isDesktop) {
        console.log('打开小程序：isDesktop： true') // 怀疑指代的是电脑版微信打开的浏览器的意思
      }  else {
        console.log('打开小程序：not isDesktop not weixin：')
        var c = new cloud.Cloud({
          // 必填，表示是未登录模式
          identityless: true,
          // 资源方 AppID
          resourceAppid: 'wx264f4850dc92b03d', // <!-- replace -->
          // 资源方环境 ID
          // resourceEnv: 'meutest-5g70zg0q6ba75a5a', // <!-- replace -->
        })
        await c.init()
        window.c = c

        var buttonEl = document.getElementById('public-web-jump-button')
        var buttonLoadingEl = document.getElementById('public-web-jump-button-loading')
        try {
          await this.openWeapp(() => {
            console.log('打开小程序 enter openWeapp')
            /* buttonEl.classList.remove('weui-btn_loading')
            buttonLoadingEl.classList.add('hidden') */
          })
        } catch (e) {
          console.log('打开小程序 enter catch')
         /*  buttonEl.classList.remove('weui-btn_loading')
          buttonLoadingEl.classList.add('hidden') */
          throw e
        }
      }
    },
    async openWeapp(onBeforeJump) {
      console.log('enter openWeapp')
      var c = window.c
      const res = await c.callFunction({
        name: 'public',
        data: {
          action: 'getUrlScheme',
        },
      })
      console.warn(res)
      if (onBeforeJump) {
        onBeforeJump()
      }
      location.href = res.result.openlink
    },
    initWxMedia(audio){
      wx.config({
        debug:false,
        appId:"",
        timestamp:1,
        nonceStr:"",
        signature:"",
        jsApiList:[]
      });
      wx.ready(()=>{
        console.log('wx环境准备就绪')
        this.isWeiXin = true
        audio?.play?.();

        if (window.WeixinJSBridge) {
          console.log('window.WeixinJSBridge')
          /* window.WeixinJSBridge.invoke('getNetworkType', {}, (res)=>  {
            // 在这里拿到 e.err_msg, 这里面就包含了所有的网络类型
            // alert(res.err_msg);
            //_that.audioObj.load()
            console.log('enter invoke getNetworkType')
          }); */
        } else{
          console.log('!!! window.WeixinJSBridge')
        }

      })

      //if(typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function'){
    },
    onPauseVideo (index) {
      console.log('onPauseVideo index / isTakingEnd:' + index + this.isTakingEnd)
      // 当说话视频被暂停 且 讲话完整结束时
      if (index === 0){ //  && this.isTakingEnd
        this.showTalkVideo = false // 展示乱动视频
      }
      if (index === 1){
        this.isVideo1Pause = true
      }
    },
    onCloseMediaDialog(isShow) {
      // 不走这个通道 因为跳转到商城无法触发该条件
      this.mediaDialog = isShow

      /* this.productCloseCount++
      // 停止声音 拦截回答和后续播放
      this.clearProductReading()
      this.stopAllMedia('onCloseMediaDialog')
      this.productCloseCount++
      // 检验点击商品次数3次播放完成后弹窗播放内容
      if (this.productCloseCount > 3 && !this.showLiuYanEnd){
        console.log('触发留言弹窗条件')
        this.showLiuYan()
      } */
    },
    productVideoClick(name) {
      // 咨询按钮点击后结束对话，改变咨询按钮状态, 咨询中也强制结束
      if (!this.adviceClickEnd){
        this.adviceClickEnd = true
      }

      // 如果当前有播放则停止播放
      try {
        console.log('触发 controllerAbort()')
        controllerAbort();
      } catch (error) {
        console.error(
          `🚀 ~ file: index.vue:242 ~ videoClick ~ error : `,
          error
        );
      }

      if (this.$refs?.InputTool?.getRecorderStatus?.()) {
        this.$refs?.InputTool?.cancelRecorder?.();
        // 需要 return 不然会一直往下走
        return;
      }
      const stop = () => {
        /* 有可能第一次播放有延时,每次都清空和停止播放吧 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
        // 先清空再停止播放
        this.TTSList = [];
        this.isAudioPlaying = false

        // 清理ended监听
        for (let i=0; i < this.audioInitPool.length; i++){

          const refName = `myAudio${i}`;
          const domAudio = this.$refs[refName][0];
          // console.log('domAudio:', domAudio)
          domAudio.removeEventListener('ended', this.onAudioEnded)
        }

        this.clearAudioList();
        this.changeSendMsgLoading(false)
        // 停止音频触发 视频暂停 ，否则视频停了，声音还在播
        console.log('停止音频触发 视频暂停 ，否则视频停了，声音还在播')

        this.stopAllMedia('onVideoClick')

        if (this.currAudio != null){
          this.currAudio.pause()
          this.currAudio = null
          this.clearAudioList()
        }
        this.clearProductReading();
      };

      // 正在播放的话，点击停止播放，并清空待播放列表
      if (this.isAudioPlaying === true) {
        console.log(' 正在播放的话，点击停止播放，并清空待播放列表')
        console.warn(
          `🚀 ~ file: index.vue:233 ~ videoClick ~ this.isAudioPlaying == true : `
        );
        stop();
        return;
      }
      stop();
    },
    videoClick(name) {
      console.warn(
        `🚀 ~ file: index.vue:222 ~ videoClick ~ videoClick : `,
        name, readTime()
      );

      if (this.$refs?.InputTool?.getRecorderStatus?.()) {
        this.$refs?.InputTool?.cancelRecorder?.();
        // 需要 return 不然会一直往下走
        return;
      }

      // 关闭购物车更多展示 和个人资料卡查看 废弃需求
      // this.onClickShoppingCar(false)
      // this.changePanelShow(false)

      // 停止多模态咨询动效
      if (!this.adviceClickEnd){
        this.adviceClickEnd = true // 咨询按钮点击后结束对话，改变咨询按钮状态
      }

      // 第一次点击
      // 新增逻辑 没必要去中断和清空播放列表
      if (!this.firstPlayed) {
        console.log('第一次点击 触发你好问候')
        this.$refs?.InputTool?.helloClick?.()
        return
      } else {
        // 先停再清空 TTSList ，不然里面可能会再添加
        // 没播放也要终止接口
        // 都停一下吧
        try {
          console.log('触发 controllerAbort()')
          controllerAbort();
          this.resetFirstData()
        } catch (error) {
          console.error(
            `🚀 ~ file: index.vue:242 ~ videoClick ~ error : `,
            error
          );
        }
      }

      const stop = () => {
        /* 有可能第一次播放有延时,每次都清空和停止播放吧 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
        // 先清空再停止播放
        this.TTSList = [];
        this.isAudioPlaying = false

        // 清理ended监听
        for (let i=0; i < this.audioInitPool.length; i++){
          const refName = `myAudio${i}`;
          const domAudio = this.$refs[refName][0];
          // console.log('domAudio:',domAudio)
          domAudio.removeEventListener('ended', this.onAudioEnded)
        }

        this.clearAudioList();
        this.changeSendMsgLoading(false)
        // 停止音频触发 视频暂停 ，否则视频停了，声音还在播
        console.log('停止音频触发 视频暂停 ，否则视频停了，声音还在播')


        /* if (this.isiOS){
          this.stopMedia("myAudio0", "when videoClick");// mark 3  stopMedia myAudio
          //this.audioEnded('videoClick');
          this.stopMedia("myVideo", "audioEnded");
        } else {
          // this.stopMedia("myAudio", "when videoClick");
          // this.audioEnded('videoClick');
          /!* this.stopMedia("myAudio0", "when videoClick"); // 主要针对第一句 你好
          this.stopMedia("myVideo", "audioEnded"); *!/
          this.stopAllMedia('onVideoClick')
          // noah add 现象：非ios端声音连续播放时，无法有效暂停导致混音 新逻辑：每个独立的nextAudio还在播 需要停止
          console.log('this.currAudio', this.currAudio)
        } */

        this.stopAllMedia('onVideoClick')

        if (this.currAudio != null){
          this.currAudio.pause()
          this.currAudio = null
          this.clearAudioList()
        }
        this.clearProductReading();
        /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */
      };

      // 正在播放的话，点击停止播放，并清空待播放列表
      if (this.isAudioPlaying === true) {
        console.log(' 正在播放的话，点击停止播放，并清空待播放列表')
        console.warn(
          `🚀 ~ file: index.vue:233 ~ videoClick ~ this.isAudioPlaying == true : `
        );
        stop();
        return;
      }
      stop();

      if (name === 'stopVideo') {
        return
      }
      // 停止产品咨询的效果


      //console.log(this.$refs?.InputTool?.sendBtnLoading )
      if (this.$refs?.InputTool?.sendBtnLoading === false) {
        /* const askList = [
          "以第一人称视角简短的介绍你个人的专业背景，不超50个字",
          "以第一人称视角简短的介绍产品和服务的特点，不超50个字",
          "以第一人称视角简短的介绍个人的专业背景，不超50个字",
          "以第一人称视角简短的介绍企业背景，不超50个字",
          "以第一人称视角简短的介绍产品给客户的价值，不超50个字",
          "以第一人称视角简短的介绍最近的优惠活动，不超50个字",
          "以第一人称视角简短的介绍所从事领域的观点，不超50个字",
        ]; */
        /* const askList = [
          "以第一人称视角简短的讲解客户为什么需要你的产品",
          "以第一人称视角简短的讲解什么样的客户需要你的产品",
          "以第一人称视角简短的介绍产品和服务的特点",
          "以第一人称视角简短的介绍产品给客户的价值",
          "以第一人称视角简短的介绍所从事领域的观点"
        ];
        const min = 0; // >=
        const max = askList.length; // <
        const index = Math.floor(Math.random() * (max - min)) + min;
        console.warn(
          `🚀 ~ file: index.vue:242 ~ videoClick ~ index : `,
          index,
          askList[index]
        ); */
        this.changePanelShow(false) // 关闭个人信息面板
        let newPromptStr = '根据专业领域知识内容，向客户种草你的产品和服务，可通过案例等说明并佐证你的专业领域观点，让种草内容更有吸引力。不超过100个字。'
        // this.$refs?.InputTool?.sendMsgClick?.(newPromptStr); // askList[index]
        // 清空提问框
        this.$refs?.RobotReplyContainer?.changeQuestionMsg?.({ content: '' });
        this.sendMsg(newPromptStr, '种草', true)
      }
    },
  randomNonsense() {
    // 废话文学
    const askList = [
      'oh，嗨！',
      '嗯嗯~',
      '嗨！',
      '哈喽~',
    ]
    const min = 0
    const max = askList.length
    const index = Math.floor(Math.random() * (max - min)) + min
    console.warn(`🚀 ~ file: indexDoubleVideo.vue:242 ~ randomNonsense ~ index : `, index, askList[index])
    return askList[index]
  },
  randomNonsense2() {
    // 废话文学
    const askList = [
      '哦哦，了解。',
      '嗯嗯，了解。',
      '嗯嗯，明白。',
      '嗯呢，好的。',
      '是这样',
      '好的，明白',
      '嗯...'
    ]

    const min = 0
    const max = askList.length
    const index = Math.floor(Math.random() * (max - min)) + min
    console.warn(`🚀 ~ file: indexDoubleVideo.vue:242 ~ randomNonsense ~ index : `, index, askList[index])
    return askList[index]
  },
  sConsole(t1, t2, a, b) {
    if (t1 === "video") {
      console.warn(`🚀 ~ sConsole a, b : `, t1, t2, a, b);
      return;
    }
    console.error(`🚀 ~ sConsole a, b : `, t1, t2, a, b);
  },
  clearTTSList() {
    this.TTSList = [];
  },
  clearAudioList(){
    this.testAudioList = []
    this.audioPlayPool = []
    this.originAudioList = []
    this.answerIndex = 0;
    this.playAudioIndex = 0;
  },
  clearTimeOutClearASRShowTimer() {
    if (this.timeOutClearASRShowTimer) {
      clearTimeout(this.timeOutClearASRShowTimer);
      this.timeOutClearASRShowTimer = null;
    }
  },
  timeOutClearASRShow(fn = () => {}) {
    this.timeOutClearASRShowTimer = setTimeout(() => {
      this.changeASRShow(false);
      this.changeASRText("");
      if (fn) {
        fn();
      }
      this.clearTimeOutClearASRShowTimer();
    }, 1000 * 2);
  },
  changeASRShow(data) {
    this.clearTimeOutClearASRShowTimer();
    this.$refs?.RobotReplyContainer?.changeASRShow?.(data);
  },
  changeASRText(data, showContent, textStatus) {
    this.clearTimeOutClearASRShowTimer();
    this.$refs?.RobotReplyContainer?.changeASRText?.(data, showContent, textStatus);
  },
  firstPlayAllMedia() {
    console.warn(
      `\n<<<<<<<<<<firstVideo firstClick 第一次点击 由此开始 : ${new Date()} \n`
    );

    // const myVideo = this.$refs?.myVideo;

    //点了按钮马上播视频，会有声音延迟的问题
    // if (myVideo) {
    //   myVideo?.play?.();
    //   // this.$nextTick(() => {
    //   //   myVideo?.pause?.();
    //   //   myVideo.currentTime = 0;
    //   // });
    // // }
    // const myAudio = this.$refs?.myAudio;
    // if (myAudio) {
    //   myAudio?.play?.();
    //   // this.$nextTick(() => {
    //   //   myAudio?.pause?.();
    //   //   myAudio.currentTime = 0;
    //   // });
    // }
    const myAudio = this.$refs?.myAudio0[0];
    const myVideo = this.$refs?.myVideo;
    const myVideo1 = this.$refs?.myVideo1;
    const playMedia = () => {
      // 播放声音 当播放时伴随播放说话视频
      if (myAudio) {
        myAudio.addEventListener('playing',()=>{
          this.firstPlayed = true // 主要用来点击后再加载商品列表 和 隐藏海报图
          this.showTalkVideo = true // 显示说话视频
          // 首次音频伴随讲话视频的播放
          this.changeSendMsgLoading(false)
          if (myVideo) {
           // 伴随播放说话的视频
            // myVideo.currentTime = 0; //noah 首点视频
            this.isAudioPlaying = true
           /*  try {
              myVideo?.play?.()
            }catch (error){
              console.log('play video error when play first:', error)
            } */
            const playPromise = myVideo.play()
            if(playPromise !== undefined){
              playPromise.then( res =>{
                // console.log('playPromise res', res)
              }).catch( error =>{
                console.log('playPromise error', error)
              })
            }
          }
        })

        const playThisAudio = ()=>{
          try {
            if (myAudio){
              // myAudio.addEventListener('ended', onAudioEnded) // 改为获得url的时候去做了监听
              myAudio?.play?.()
              for (let i = 0; i < this.audioInitPool.length; i++){
                if (i !== 0){
                  const refName = `myAudio${i}`;
                  const domAudio = this.$refs[refName][0];
                  domAudio.muted = true
                  domAudio?.play?.()
                }
              }

            }
          }catch (error){
            console.log('play video error when play first:', error)
          }
        }
        playThisAudio()
      }
    };

    const playMediaSetTimeout = () => {
      setTimeout(() => {
        /* myVideo?.pause?.();
        myVideo.currentTime = 0;
        myAudio?.pause?.();
        myAudio.currentTime = 0; // 会触发ended事件 引发停止视频，循环play pause错误 */

          // 关键这里的play类似于主线程 猜测iOS只能这里监听的主动交互

          // 对两个视频进行主动触发播放
          const playThisVideoSlice = ()=>{
            myVideo1.currentTime = 0;
            try {
              myVideo1?.play?.()
              // this.showTalkVideo = false // 先显示眨眼视频
            }catch (error){
              console.log('play video1 error when play first:', error)
            }
          }
          // 对两个视频进行触发播放
          myVideo.play()
          playThisVideoSlice()

          setTimeout(() => {
            // 第一次会调 event事件的方法来播放，然后移动端报未触发播放错误
            // 所以点完之后再赋予event 事件
            this.audioPlay = this.audioPlayFn
            this.audioLoadedmetadata = this.audioLoadedmetadataFn

            // 视频播放了可能音频未就绪 主动暂停讲话的视频
            myVideo.pause()

            // 要先设置完再播，不然第一次点击不会停，会chat
            playMedia();
          }, 150);
        }, 50);
      }

      // noah add
      // playMedia 第一次播放并不代表音视频都已经就绪了

      playMediaSetTimeout() // 设计了加载框等待音频数据加载完成 按照监听事件里播放视频，ios微信会错误播放不了视频

      /* if (!this.needPrompt || !this.markThree){
        // 3s内播放预设提示音
        playMediaSetTimeout() // 设计了加载框等待音频数据加载完成 按照监听事件里播放视频，ios微信会错误播放不了视频
      } else {
        const playThisAudio = ()=>{
          try {
            for (let i = 0; i < this.audioInitPool.length; i++){
              const refName = `myAudio${i}`;
              const domAudio = this.$refs[refName][0];
              domAudio.muted = true
              domAudio?.play?.()
            }
          }catch (error){
            console.log('play video error when play first:', error)
          }
        }
        playThisAudio()
        this.judgeActivePrompt()
      } */


      // 设计监听就绪逻辑，互相监听都就绪了则进行同步播放
      /* if (this.isFirstAudioCanPlay && this.isFirstAudioCanPlay){
        console.log('test 1 音视频都就绪了')
        playMediaSetTimeout()
      } else {
        console.log('test 1 音视频还未就绪，加入监听')
        myAudio.addEventListener('canplay',()=>{
          console.log('第一次播放 音频准备就绪')
          // this.isFirstAudioCanPlay = true
          // console.log('videoUrl:', this.videoUrl)
          if (this.isFirstVideoCanPlay){
            playMediaSetTimeout()
          }
        })

        myVideo.addEventListener('canplay',()=>{
          this.isFirstVideoCanPlay = true
          console.log('第一次播放 视频准备就绪')
          if (this.isFirstAudioCanPlay){
            playMediaSetTimeout()
          }
        }, false)
      } */
      // 视频先不管
      /* if (this.isFirstAudioCanPlay){
        console.log('test 1 音视频都就绪了')
        playMediaSetTimeout()
      } else {
        console.log('test 1 音视频还未就绪，加入监听')
        myAudio.addEventListener('loadedmetadata',()=>{
          console.log('第一次播放 音频loadedmetadata准备就绪')
          playMediaSetTimeout()
        })
      } */

    },
    clearProductReading() {
      this?.$refs?.ProductList?.clearReading?.();
    },
    audioPlay() {
      // 每次播放时，停用录音，防止录音时点击商品介绍
      this.$refs?.InputTool?.cancelRecorder?.();
    },
    audioPlayFn() {
      console.log('enter audioPlayFn() when audio playing')
      this.playVideo("", "audioPlayFn");
      // 每次播放时，停用录音，防止录音时点击商品介绍
      this.$refs?.InputTool?.cancelRecorder?.();
      this.isAudioPlaying = true;


      // 播放视频是才停止加载并展现文字
      this.$refs?.RobotReplyContainer?.changeMsg?.({
        content: this.currentTTSText,
      });
      this.changeSendMsgLoading(false, "audioPlayFn");
    },
    audioError(name, index) {
      this.isAudioPlaying = false;
      // 自动停止视频
      this.stopMedia("myVideo", "audioEnded", name);
      this.clearProductReading();
      console.error(
        `\n>>>>>>>>>>>>>>>>>>>>>>>>>> 播放  错误 结束 :  ${name} + ' index:' ${index} ,${new Date()}\n`
      );
      // 声音播放错误最好停一下加载，因为接口成功时其实没做停止加载
      this.changeSendMsgLoading(false, "audioError");
    },
    audioAbort(name, index) {
      console.error(
        `\n>>>>>>>>>>>>>>>>>>>>>>>>>> 播放  终端  结束 : ${name} + ' index:' ${index} ,  ${new Date()}\n`
      );
    },
    onAudioEndedSelf(name, index) {
      console.log('enter 自带的onAudioEnded，来源：' + name + ' index:' + index)
      /*
      // 删除刚播完的文本
      this.TTSList.shift();
      if (this.TTSList.length === 0) {
        this.isAudioPlaying = false;
        // 自动停止视频
        this.stopMedia("myVideo", "audioEnded", name);
        this.clearProductReading();

        // 不清空不复位
        // this.$refs?.RobotReplyContainer?.changeMsg?.({ content: "" });
        console.warn(
          `\n>>>>>>>>>>>>>>>>>>>>>>>>>> 无 TTSList 了，播放到此结束 ${name} : ${new Date()}\n`
        );
      }
      else { // noah modify
        console.log('enter audioEnded name:'+ name )
        console.log('enter audioEnded:text'+ this.TTSList[0]?.text )
        this.sendMsgAnswerShowAndPlay(this.TTSList[0]?.text);
      } */
      this.isAudioPlaying = false;
      // 自动停止视频
      this.stopMedia("myVideo", "audioEnded", name);
    },
    resetFirstData(){
      console.log('清空enter resetFirstData')
      this.requestIndex = -1
      this.playAudioIndex = 0
      this.requestList = []
      clearRequestArray()
    },
    resetFirstIndex(){
      // 因为废话文学 重置index 不重置原始队列
     /*  console.log('清空enter resetFirstIndex')
      this.requestIndex = -1
      this.playAudioIndex = 0 */
    },
    onFirstAudioEnded(event) {
      // 因为首句话播放完成后 this.playAudioIndex 加1 为 1
      // 而 原始队列被删除了一个 放进去的时候是index 是0 故匹配不上
      this.playAudioIndex = this.playAudioIndex + 1
      console.log(this.testName, '当前播放结束，当前playAudioIndex：' + this.playAudioIndex + ' / ' + readTime())
      this.isAudioPlaying = false;
      // 自动停止视频
      this.stopMedia("myVideo", "audioEnded")
      const currentAudio = event.target;
      // console.log('event target:', currentAudio)
      // 在需要的时候移除 ended 事件监听器
      currentAudio.removeEventListener('ended', this.onFirstAudioEnded)
      // console.log('this.requestList.length', this.requestList.length)
      // console.log('this.requestList', this.requestList)
      // 下一句匹配index
      if(this.requestList.length > 0){
        console.log('will shiftOriginList，还未删除首个前的requestList：', this.requestList[0])
        if (this.requestList[0].index === 0){
          this.changeSendMsgLoading(true)
        }

        /* if(this.requestList.length > 1){
          const firstAudio = this.requestList[0]
          if(firstAudio.url && firstAudio.url !== '' && firstAudio.index !== 0){
            this.playFirstAudio(firstAudio)
          } else {
            console.log('播放完成后衔接的下一句话不满足url：', firstAudio)
          }
        }*/
        if(this.requestList.length > 1){
          const nextAudio =  this.requestList[1]
          this.requestList = shiftOriginList() // 首句有url才播
          console.log('播放完成，删除首个后的requestList的长度', this.requestList.length)
          console.log('this.requestList：', this.requestList)
          if(nextAudio.url && nextAudio.url !== ''){
            this.playFirstAudio(nextAudio)
          } else {
            console.log('播放完成后衔接的下一句话不满足url：', nextAudio)
          }
        } else if(this.requestList.length === 1){
          // 针对废话文学播放完成
          this.requestList = shiftOriginList() // 首句有url才播
        }
        else {
          // 清空播放队列了 可能是废话完成 也可能是整个句子完成
          const stop = () => {
            this.helloBtnClick = false
            console.log('当前问题回答播放完毕 this.testAudioList.length:')
            this.isTakingEnd = true

            this.stopMedia('myVideo', 'playVideo')
            // this.stopMedia('myAudio' + (this.playAudioIndex % this.audioPoolMax), 'audioEnded')
            this.clearProductReading()
            clearAllStr()

            this.isAudioPlaying = false
            if (!this.adviceClickEnd){
              this.adviceClickEnd = true // 咨询按钮点击后结束对话，改变咨询按钮状态
            }
            // nextAudio = null
            this.clearAudioList()
            this.clearTTSList()

            // 不放进来，如果回答较长时间出发定时器，导致问题的中断回答
            // 主动交互逻辑 开启定时器
            if (this.needPrompt){
              console.log('所有问题回答完后开始新一轮的定时器')
              this.startPromptTimer()
            }
          }

          // 正在播放的话，点击停止播放，并清空待播放列表
          if (this.isAudioPlaying === true) {
            console.log(' 正在播放的话，点击停止播放，并清空待播放列表 in mark 1')
            stop()
            return
          }
          stop()

          if (!this.firstPlayEnd){
            console.log('第一次主动提示音播放完成')
            this.firstPlayEnd = true
            this.resetFirstIndex()
          }

          /* 以下是主动交互部分 */
          // 检测提问中是否涉及联系方式 进行弹窗
          if(this.priorityLock){
            this.changeSendMsgLoading(true)
          } else {
            this.changeSendMsgLoading(false)
            if (this.currentQuestion.includes('微信') || this.currentQuestion.includes('联系方式') || this.currentQuestion.includes('群聊')){
              console.log("提问中涉及联系方式进行弹窗'")
              this.currentQuestion = ''
              this.showQRGroupDialog()
            } else {
              this.currentQuestion = ''
              // 三个弹窗进行判断
              let index = this.judgeAlert()
              console.log('判断是否弹窗 index：', index)
              if(index === 0){
                // 群二维码弹窗
                this.showQRGroupDialog()
              } else if(index === 1){
                // 留言弹窗
                this.showLiuYan()
              } else if(index === 2){
                this.showCareLove()
              }
            }
          }

        }
      }


    },
    onAudioEnded(event){
      console.log('enter 进入老版本的 onaudioended')
      // 监听播放完成，ended 事件不准确
      this.playAudioIndex = this.playAudioIndex + 1
      console.log(this.testName, '当前播放结束，下一个playAudioIndex：' + this.playAudioIndex + ' / ' + readTime())
      console.log('当前播放结束，是否解锁：' + this.priorityLock)
      console.log('this currListLen：' + this.testAudioList.length) // playAudioIndex 3 currListLen：6
      /* console.log('播放完成停止的 将下一个的playAudioIndex：'+ this.playAudioIndex)
      console.log('nextAudio onEnded,testAudioList length:' + this.testAudioList.length)
      console.log('******播放完成，剩余句子数量：'+ this.testAudioList.length)
      console.log('******audioPlayPool：', this.audioPlayPool) */

      this.isAudioPlaying = false;
      // 自动停止视频
      this.stopMedia("myVideo", "audioEnded");

      // 在需要的时候移除 ended 事件监听器
      // 获取当前的音频元素
      const currentAudio = event.target;
      // console.log('event target:', currentAudio)
      // 在需要的时候移除 ended 事件监听器
      currentAudio.removeEventListener('ended', this.onAudioEnded)
      // this.stopMedia("myVideo", "playVideo"); // self 监听自带了
      // this.stopMedia("myAudio" + (this.answerIndex % this.audioPoolMax), "audioEnded");

      // recheck 播完了正是回答的第一句话 将要播第二句：
      if (this.playAudioIndex === 3 && this.testAudioList.length > this.audioPoolMax){
        console.log('enter recheck audio 0')
        // 第六句话替换为第一个audio index为0的
        // 第二句话播放完，去recheck和重新赋值第一个audio

        let newAudioModel = this.testAudioList[5]
        //console.log('替换数据为 this.testAudioList的' +  (this.audioPoolMax + this.playAudioIndex)  + '条：',newAudioModel)
        let newAudioModelSrc = newAudioModel.url
        let replaceAudioModel =  this.audioPlayPool[0]
        //console.log('替换播放列表数据的 的' +  ((this.playAudioIndex - 1) % this.audioPoolMax)  + '条：', replaceAudioModel)
        let replaceAudio = replaceAudioModel.nextAudio
        replaceAudio.src = newAudioModelSrc
        replaceAudio.text = newAudioModel.text
        // replaceAudio.addEventListener("ended", onAudioEnded)

        replaceAudioModel.url = newAudioModelSrc
        replaceAudioModel.text = newAudioModel.text
        replaceAudioModel.nextAudio = replaceAudio
        this.audioPlayPool[0] = replaceAudioModel
        // console.log('this.audioPlayPool', this.audioPlayPool)
      }

      // 当播放列表结束一个，预载新的url进去
      if (this.testAudioList.length > this.audioPoolMax + this.playAudioIndex - 1){
        //console.log('enter 当播放列表结束一个，预载新的url进去,替换前的audioPlayPool声音池：', this.audioPlayPool)
        let newAudioModel = this.testAudioList[this.audioPoolMax + this.playAudioIndex - 1]
        //console.log('替换数据为 this.testAudioList的' +  (this.audioPoolMax + this.playAudioIndex)  + '条：',newAudioModel)
        let newAudioModelSrc = newAudioModel.url
        let replaceAudioModel =  this.audioPlayPool[(this.playAudioIndex - 1) % this.audioPoolMax]
        //console.log('替换播放列表数据的 的' +  ((this.playAudioIndex - 1) % this.audioPoolMax)  + '条：', replaceAudioModel)
        let replaceAudio = replaceAudioModel.nextAudio
        replaceAudio.src = newAudioModelSrc
        replaceAudio.text = newAudioModel.text
        // replaceAudio.addEventListener("ended", onAudioEnded)

        replaceAudioModel.url = newAudioModelSrc
        replaceAudioModel.text = newAudioModel.text
        replaceAudioModel.nextAudio = replaceAudio

        this.audioPlayPool[(this.playAudioIndex - 1) % this.audioPoolMax] = replaceAudioModel
        //console.log('当播放列表结束一个，预载新的url进去 new:', this.audioPlayPool)
      }



      // 二次检查 当前对话结束后 检查上一个audio的对称语句是否存在

      if (this.playAudioIndex < this.testAudioList.length){
        if (this.isiOS){
          this.changeSendMsgLoading(true) // 针对ios因为加载较慢，所以加上等待效果
        }

        // 下一个播放列表中的audio开始播放
        console.log('声音池中的下一个audio即将准备播放:' , this.playAudioIndex % this.audioPoolMax)
        let okAudioModel = this.audioPlayPool[this.playAudioIndex % this.audioPoolMax]
        const okAudio = okAudioModel.nextAudio
        const okAudioText = okAudioModel.text
        okAudio.text = okAudioText


        // console.log('okAudio:', okAudio)
        okAudio.addEventListener('playing', this.onAudioPlayingListenEvent)
        okAudio.addEventListener('ended', this.onAudioEnded)

        //this.currentTTSText = okAudioText
        console.log('将播放的文本为：' + okAudioText + '.')


        const isWhitespaceOrEmpty = (input)=> {
          // 使用正则表达式来匹配空字符串或者只包含空格的字符串
          return /^(\s*|)$/.test(input);
        }
        // 存在空白字符的情况
       /*  if (!isWhitespaceOrEmpty(okAudioText)){

        } */

        // 存在给产品1写一首72字的七言绝句 后面存在两个空格的字符串
         // 重置时间在前然后再取消静音
        const playAudio = () => {
          okAudio.currentTime = 0
          okAudio.muted = false
          okAudio.pause()

          console.log(this.testName, '下一个音频进行播放：' + readTime())
          if (okAudio.paused) {
            okAudio.play() // 只有在媒体元素处于暂停状态时才调用 play() 方法
          } else {
            okAudio.load() // 先重新加载媒体资源
            okAudio.play() // 然后再调用 play() 方法
          }
        }
        try {
          playAudio()
        }catch (error){
          console.log('声音池中的一个声音播放时错误:', error)
        }

      }
      else {
        const stop = () => {
          this.helloBtnClick = false
          console.log('当前问题回答播放完毕 this.testAudioList.length:')
          this.isTakingEnd = true

          this.stopMedia('myVideo', 'playVideo')
          this.stopMedia('myAudio' + (this.playAudioIndex % this.audioPoolMax), 'audioEnded')
          this.clearProductReading()
          clearAllStr()

          this.isAudioPlaying = false
          if (!this.adviceClickEnd){
            this.adviceClickEnd = true // 咨询按钮点击后结束对话，改变咨询按钮状态
          }
          // nextAudio = null
          this.clearAudioList()
          this.clearTTSList()

          // 不放进来，如果回答较长时间出发定时器，导致问题的中断回答
          // 主动交互逻辑 开启定时器
          if (this.needPrompt){
            console.log('所有问题回答完后开始新一轮的定时器')
            this.startPromptTimer()
          }
        }

        // 正在播放的话，点击停止播放，并清空待播放列表
        if (this.isAudioPlaying === true) {
          console.log(' 正在播放的话，点击停止播放，并清空待播放列表 in mark 1')
          stop()
          return
        }
        stop()

        if (!this.firstPlayEnd){
          console.log('第一次主动提示音播放完成')
          this.firstPlayEnd = true
        }



        /* 以下是主动交互部分 */
        // 检测提问中是否涉及联系方式 进行弹窗
        if(this.priorityLock){
          this.changeSendMsgLoading(true)
        } else {
          this.changeSendMsgLoading(false)

          if (this.currentQuestion.includes('微信') || this.currentQuestion.includes('联系方式') || this.currentQuestion.includes('群聊')){
            console.log("提问中涉及联系方式进行弹窗'")
            this.currentQuestion = ''
            this.showQRGroupDialog()
          } else {
            this.currentQuestion = ''
          }

          // 判断是否触发群二维码弹窗 访问数组大于5 且当天没展示过二位码弹窗（ 一天累计访问超过五次，弹出一次群二维码弹窗且播放语音）
          /* if (this.$store.state.visitList.length > 3 && !this.$store.state.showQRCodeDialogEnd){
            console.log('enter showQRGroupDialog')
            this.showQRGroupDialog()
          } */

          // 判断是否可关注 且 未关注
          /* if(this.$store.state.weiXinMark && !this.isCare){
            console.log('enter 判断是否关注')
            // 访问次数大于三次且未展示过关注
            if ( this.globalClickCount > 3  && !this.showCareLoveShowEnd){
              this.showCareLove()
            }
          } */
        }


      }
    },
    onAudioEnded2(){
      // 监听播放完成，ended 事件不准确
      this.playAudioIndex = this.playAudioIndex + 1
      console.log(this.testName, '当前播放结束，下一个playAudioIndex：' + this.playAudioIndex + ' / ' + new Date().getTime())
      console.log('当前播放结束，是否解锁：' + this.priorityLock)
      const currListLen = this.testAudioList.length
      console.log('this currListLen：' + currListLen) // playAudioIndex 3 currListLen：6
      /* console.log('播放完成停止的 将下一个的playAudioIndex：'+ this.playAudioIndex)
      console.log('nextAudio onEnded,testAudioList length:' + this.testAudioList.length)
      console.log('******播放完成，剩余句子数量：'+ this.testAudioList.length)
      console.log('******audioPlayPool：', this.audioPlayPool) */

      this.isAudioPlaying = false;
      // 自动停止视频
      this.stopMedia("myVideo", "audioEnded");



      // this.stopMedia("myVideo", "playVideo"); // self 监听自带了
      // this.stopMedia("myAudio" + (this.answerIndex % this.audioPoolMax), "audioEnded");

      // recheck 播完了正是回答的第一句话 将要播第二句：
      if (this.playAudioIndex === 3 && this.testAudioList.length > this.audioPoolMax){
        console.log('enter recheck audio 0')
        // 第六句话替换为第一个audio index为0的
        // 第二句话播放完，去recheck和重新赋值第一个audio

        let newAudioModel = this.testAudioList[5]
        //console.log('替换数据为 this.testAudioList的' +  (this.audioPoolMax + this.playAudioIndex)  + '条：',newAudioModel)
        let newAudioModelSrc = newAudioModel.url
        let replaceAudioModel =  this.audioPlayPool[0]
        //console.log('替换播放列表数据的 的' +  ((this.playAudioIndex - 1) % this.audioPoolMax)  + '条：', replaceAudioModel)
        let replaceAudio = replaceAudioModel.nextAudio
        replaceAudio.src = newAudioModelSrc
        replaceAudio.text = newAudioModel.text
        // replaceAudio.addEventListener("ended", onAudioEnded)

        replaceAudioModel.url = newAudioModelSrc
        replaceAudioModel.text = newAudioModel.text
        replaceAudioModel.nextAudio = replaceAudio
        this.audioPlayPool[0] = replaceAudioModel
        // console.log('this.audioPlayPool', this.audioPlayPool)
      }

      // 当播放列表结束一个，预载新的url进去
      if (this.testAudioList.length > this.audioPoolMax + this.playAudioIndex - 1){
        //console.log('enter 当播放列表结束一个，预载新的url进去,替换前的audioPlayPool声音池：', this.audioPlayPool)
        let newAudioModel = this.testAudioList[this.audioPoolMax + this.playAudioIndex - 1]
        //console.log('替换数据为 this.testAudioList的' +  (this.audioPoolMax + this.playAudioIndex)  + '条：',newAudioModel)
        let newAudioModelSrc = newAudioModel.url
        let replaceAudioModel =  this.audioPlayPool[(this.playAudioIndex - 1) % this.audioPoolMax]
        //console.log('替换播放列表数据的 的' +  ((this.playAudioIndex - 1) % this.audioPoolMax)  + '条：', replaceAudioModel)
        let replaceAudio = replaceAudioModel.nextAudio
        replaceAudio.src = newAudioModelSrc
        replaceAudio.text = newAudioModel.text
        // replaceAudio.addEventListener("ended", onAudioEnded)

        replaceAudioModel.url = newAudioModelSrc
        replaceAudioModel.text = newAudioModel.text
        replaceAudioModel.nextAudio = replaceAudio

        this.audioPlayPool[(this.playAudioIndex - 1) % this.audioPoolMax] = replaceAudioModel
        //console.log('当播放列表结束一个，预载新的url进去 new:', this.audioPlayPool)
      }



      // 二次检查 当前对话结束后 检查上一个audio的对称语句是否存在

      if (this.playAudioIndex < this.testAudioList.length){
        if (this.isiOS){
          this.changeSendMsgLoading(true) // 针对ios因为加载较慢，所以加上等待效果
        }

        // 下一个播放列表中的audio开始播放
        console.log('声音池中的下一个audio即将准备播放:' , this.playAudioIndex % this.audioPoolMax)
        let okAudioModel = this.audioPlayPool[this.playAudioIndex % this.audioPoolMax]
        const okAudio = okAudioModel.nextAudio
        const okAudioText = okAudioModel.text
        okAudio.text = okAudioText


        // console.log('okAudio:', okAudio)
        okAudio.addEventListener('playing', this.onAudioPlayingListenEvent)
        okAudio.addEventListener('ended', this.onAudioEnded)

        //this.currentTTSText = okAudioText
        console.log('将播放的文本为：' + okAudioText + '.')


        const isWhitespaceOrEmpty = (input)=> {
          // 使用正则表达式来匹配空字符串或者只包含空格的字符串
          return /^(\s*|)$/.test(input);
        }
        // 存在空白字符的情况
        /*  if (!isWhitespaceOrEmpty(okAudioText)){

         } */

        // 存在给产品1写一首72字的七言绝句 后面存在两个空格的字符串
        // 重置时间在前然后再取消静音
        const playAudio = () => {
          okAudio.currentTime = 0
          okAudio.muted = false
          okAudio.pause()

          console.log(this.testName, '下一个音频进行播放：' + new Date().getTime())
          if (okAudio.paused) {
            okAudio.play(); // 只有在媒体元素处于暂停状态时才调用 play() 方法
          } else {
            okAudio.load(); // 先重新加载媒体资源
            okAudio.play(); // 然后再调用 play() 方法
          }
        }
        try {
          playAudio()
        }catch (error){
          console.log('声音池中的一个声音播放时错误:', error)
        }

      }
      else {
        const stop = () => {
          this.helloBtnClick = false
          console.log('当前问题回答播放完毕 this.testAudioList.length:')
          this.isTakingEnd = true

          this.stopMedia('myVideo', 'playVideo')
          this.stopMedia('myAudio' + (this.playAudioIndex % this.audioPoolMax), 'audioEnded')
          this.clearProductReading()
          clearAllStr()

          this.isAudioPlaying = false
          if (!this.adviceClickEnd){
            this.adviceClickEnd = true // 咨询按钮点击后结束对话，改变咨询按钮状态
          }
          // nextAudio = null
          this.clearAudioList()
          this.clearTTSList()
        }

        // 正在播放的话，点击停止播放，并清空待播放列表
        if (this.isAudioPlaying === true) {
          console.log(' 正在播放的话，点击停止播放，并清空待播放列表 in mark 1')
          stop()
          return
        }
        stop()

        if (!this.firstPlayEnd){
          console.log('第一次主动提示音播放完成')
          this.firstPlayEnd = true
        }



        /* 以下是主动交互部分 */
        // 检测提问中是否涉及联系方式 进行弹窗
        if(this.priorityLock){
          this.changeSendMsgLoading(true)
        } else {
          this.changeSendMsgLoading(false)

          if (this.currentQuestion.includes('微信') || this.currentQuestion.includes('联系方式') || this.currentQuestion.includes('群聊')){
            console.log("提问中涉及联系方式进行弹窗'")
            this.currentQuestion = ''
            this.showQRGroupDialog()
          } else {
            this.currentQuestion = ''
          }

          // 判断是否触发群二维码弹窗 访问数组大于5 且当天没展示过二位码弹窗（ 一天累计访问超过五次，弹出一次群二维码弹窗且播放语音）
          /* if (this.$store.state.visitList.length > 3 && !this.$store.state.showQRCodeDialogEnd){
            console.log('enter showQRGroupDialog')
            this.showQRGroupDialog()
          } */

          // 判断是否可关注 且 未关注
          /* if(this.$store.state.weiXinMark && !this.isCare){
            console.log('enter 判断是否关注')
            // 访问次数大于三次且未展示过关注
            if ( this.globalClickCount > 3  && !this.showCareLoveShowEnd){
              this.showCareLove()
            }
          } */

          // 不放进来，如果回答较长时间出发定时器，导致问题的中断回答
          // 主动交互逻辑 开启定时器
          if (this.needPrompt){
            this.startPromptTimer()
          }
        }


      }
    },
    onAudioPlaying(index){ // created noah
      console.log('enter onAudioPlaying() 开始播放' + index) // index undefined 原因1 可能是ios 播放结束方法中，先主动播放视频
      this.audioPlayFn()
    },
    onAudioPlayingListenEvent(event){
      console.log(this.testName, 'T start playing request 当前播放，playAudioIndex：' + this.playAudioIndex + ' / ' + readTime())
      if (this.timeCountFlag &&  this.playAudioIndex === 0){
        let currTime = new Date().getTime()
        let abs = currTime - this.timeCountABS
        this.timeCountABS = currTime
        console.log(this.timeCountTag, 'start 回复的首句开始播放 time:', abs, readTime())
      }


      // 实现了：移除监听 读取声音携带的文本
      // 再跳到onAudioPlaying()方法 audioPlayFn方法: 输入键盘 字母 消息加载框状态处理
      // this.sConsole('onAudioPlayingListenEvent playing:'  + new Date());

      this.cancelPromptTimer()

      const currentAudio = event.target
      // this.sConsole('当前的音频的时长为：' + currentAudio.duration) // 7.884
      // console.log('curr testAudioList' + this.testAudioList.length, this.testAudioList)

      let text = currentAudio.text
      this.sConsole('播放的是:'  + this.playAudioIndex + 'time:' + readTime() + (currentAudio.muted ? '，静音播放' : '，有声播放')+ ' 文本：' + text)
      // console.log('onAudioPlayingListenEvent text:' + text + '.')
      if (text !== '' || typeof text !== 'undefined'){
        this.currentTTSText = text
      }

      // 在需要的时候移除 ended 事件监听器
      currentAudio.removeEventListener('playing', this.onAudioPlayingListenEvent)

      this.currAudio = currentAudio
      /* if(!this.isiOS){
        this.onAudioPlaying(this.playAudioIndex % this.audioPoolMax)
      } noah modify 20240103 ios字幕不同步的问题*/
      this.onAudioPlaying(this.playAudioIndex % this.audioPoolMax)

      // 下一句提前播放方案：
      // console.log('next index:' + ((this.playAudioIndex % this.audioPoolMax) + 1))
      // console.log('this.testAudioList.length :' + this.testAudioList.length, this.testAudioList)
      // 这个testAudioList的长度开始是动态的，可能是1：1，后期是1-2-3-4：4
      if ((this.playAudioIndex % this.audioPoolMax) + 1 < this.testAudioList.length){
        let nextAudio = this.testAudioList[(this.playAudioIndex % this.audioPoolMax) + 1].nextAudio
        if (nextAudio !== null && typeof nextAudio !== 'undefined'){
          // nextAudio.muted = true // 测试混音 取消注释 放到下方
          // console.log('当播放时 下一个nextAudio', nextAudio.text, nextAudio)
          // 静音 播放 监听时间变化时
          /*const nextAudioDurationChange = (event) =>{

            console.log('nextAudioDurationChange on durationchange：' + new Date())
            const targetAudio = event.target
            targetAudio.removeEventListener('canplay', nextAudioDurationChange);
            targetAudio.play()
            // todo 播放完成 或设置不循环
             setTimeout(()=>{
                if (targetAudio) {
                  const pauseThisAudio = ()=>{
                    targetAudio.currentTime = 0;
                    try {
                      targetAudio?.pause?.()
                      targetAudio.currentTime = 0
                      targetAudio.muted = false
                    }catch (error){
                      console.error('pauseThisAudio error:', error)
                    }
                  }
                  pauseThisAudio()
                }
            }, 500) // 可能ios 长一些

          }
          nextAudio.addEventListener('canplay', nextAudioDurationChange)*/

          // 方案2 直接静音播 自动结束
          try {
            if (nextAudio.paused) {
              nextAudio.muted = true // 测试混音 取消注释 放到下方
              nextAudio.play(); // 只有在媒体元素处于暂停状态时才调用 play() 方法
            } else {
              nextAudio.muted = true // 测试混音 取消注释 放到下方
              nextAudio.load(); // 先重新加载媒体资源
              nextAudio.play(); // 然后再调用 play() 方法
            }
          }catch (error){
            console.log('提前静默播放声音池中的下一句时出错了', error)
          }


        }
      }
    },
    onCanplayAudio(index){
      // 第一个音频组件未加载好才能解锁界面
      if (!this.isFirstAudioCanPlay && index === 0){
        this.isFirstAudioCanPlay = true
      }
    },
    onCanplayVideo(){
      if (!this.isFirstVideoCanPlay){
        this.isFirstVideoCanPlay = true
      }
      // this.sConsole('video test canplaythrough', readTime())
    },
    onVideoLoadedMetaData() {
      // this.sConsole('video test loadedmetadata >>' , readTime())
    },
    audioLoadedmetadata(index) {
      // 第一个音频组件未加载好才能解锁界面
      if (!this.isFirstAudioCanPlay && index === 0){
        this.isFirstAudioCanPlay = true
        //this.$myToast?.clear?.();
        this.$refs?.InputTool?.setDisabledBtn(false)
        this.changeSendMsgLoading(false)
      }
    },
    audioLoadedmetadataFn(a, b) {
      this.$refs?.myAudio?.play?.(); // 调用自己播放 来触发audioPlay中的视频播放
      // this.playAudio(); // 播不了不要用
      // this.playVideo('','audioLoadedmetadataFn'); // 跟audioPlay 重复了
    },
    getMyVideo() {
      return this.$refs?.myVideo || null;
    },
    getMyAudio() {
      return this.$refs?.myAudio || null;
    },
    playVideo(src = "", name) {
      // console.log('enter playVideo() src:' + src + '.')
      // 每次播放时，停用录音，防止录音时点击商品介绍
      this.$refs?.InputTool?.cancelRecorder?.();
      // this.playMedia("myVideo", src);
      try {
        //this.stopMedia("myVideo", "playVideo", name);
        this.showTalkVideo = true // 切换双视频mark


        const myVideo = this.$refs?.myVideo;
        if (!myVideo) return;
        if (src) {
          console.log('have src will load:' + src + '.')
          myVideo.src = src;
          myVideo?.load?.(); // load不能每次都load，不然再次play会报错
        }

        try {
          // this.$nextTick(() => {
          this.isTakingEnd = false
          this.$refs.myVideo.currentTime = 0

          myVideo?.play?.();
          // });
        } catch (error) {
          console.error("myVideo?.play", error);
        }
      } catch (error) {
        console.error("playVideo ", error);
      }
    },
    playAudio(src = "") {
      this.playMedia("myAudio", src);
    },
    playMedia(refName, src = "") {
      console.log('enter playMedia()')
      // 每次播放时，停用录音，防止录音时点击商品介绍
      this.$refs?.InputTool?.cancelRecorder?.();
      try {
        //this.stopMedia(refName, "playVideo");
        const mediaElement = this.$refs?.[refName][0];
        if (!mediaElement) return;
        if (src) {
          mediaElement.src = src;
          mediaElement?.load?.(); // load不能每次都load，不然再次play会报错
        }
        // this.$nextTick(() => {
        //   try {
        //     mediaElement?.play?.();
        //   } catch (error) {
        //     console.error("mediaElement?.play", error);
        //   }
        // });
      } catch (error) {
        console.error("playMedia ", error);
      }
    },
    stopAllMedia(name) {
      console.log('enter stopAllMedia()', name)

      // 主动交互逻辑 开启定时器
      this.helloBtnClick = false
      console.log('this.needPrompt', this.needPrompt)
      if (this.needPrompt ){ // noah modify 20240911当清空请求队列时才开始定时器 && this.requestList.length === 0
        this.startPromptTimer()
      }

      this.changeSendMsgLoading(false)
      this.stopMedia("myVideo", "stopAllMedia");


      /* if(name === 'adviceClick'){
        this.isTakingEnd = true
      } */
      this.isTakingEnd = true
      this.isAudioPlaying = false
      /* if(this.howlAudio !== null){
        // 停止所有媒体播放当然包括：废话文学停止播放
        this.howlAudio?.pause?.()

      }
      this.priorityLock = false */

      for (let i=0; i < this.audioInitPool.length; i++){
        const refName = `myAudio${i}`
        const domAudio = this.$refs[refName][0]
        if(typeof domAudio !== 'undefined'){
          try{
            domAudio.pause()
          }catch(error) {
            console.log(' domAudio.pause() catch error:', error)
          }
        }
      }

      this.currAudio?.pause()
      //! !!  this.TTSList = []; 会导致只有一个所以一直只播放一句
      // this.TTSList = [];
    },
    stopMedia(refName, name, name2) {
      // console.warn("stopMedia refName:" + refName + ' event name:' + name);
      //console.log('stopMedia 将停止媒体类型：' , refName ==='myAudio' ? 'audio' : 'video', refName)
      console.log('stopMedia 将停止媒体：' , refName, '备注：', name)

      try {
        if (refName === 'myVideo'){
          const mediaElement = this.$refs?.[refName];
          if (!mediaElement) {
            console.warn("*** 无myVideo ref", refName);
            return;
          }

          // 防止多次暂停
          /*  if (mediaElement.currentTime === 0) {
             console.log("*** 已暂停 return，当mediaElement.currentTime === 0了");
             mediaElement?.pause?.();
             return;
           } */
          mediaElement?.pause?.();
          // 会循环触发canplay
          mediaElement.currentTime = 0;
        } else {
          let mediaElement
          if (typeof this.$refs?.[refName][0] === 'undefined'){
            mediaElement= this.$refs?.[refName]
          } else {
            mediaElement = this.$refs?.[refName][0]
          }
          if (!mediaElement) {
            console.warn("*** 无myAudio ref", refName);
            return;
          }
          mediaElement?.pause?.();
          // 会循环触发canplay
          mediaElement.currentTime = 0;
        }

      } catch (error) {
        console.error("playMedia ", error);
      }
    },
    async onBaiduASR(PCMBlob) {
      // console.log('index received onBaiduASR',PCMBlob)
      if (!this.vuex_baidu_asr_token) {
        this.$myToast({
          type: "fail",
          message: "无 ASR Token",
        });
        return false;
      }
      if (!PCMBlob) {
        this.$myToast({
          type: "fail",
          message: "无音频数据",
        });
        return false;
      }

      try {
        this.$refs?.InputTool?.changeLoading?.(true);

        this.changeASRShow(true);
        this.changeASRText("识别中，请稍后...", false, {'backgroundColor':'#363636','color':'#fff','text':'按住说话'});

        // this.$myToast({
        //   type: "loading",
        //   message: "识别中",
        //   forbidClick: true,
        //   overlay: true,
        //   duration: 0,
        // });

        // this.playAudio(window.URL.createObjectURL(data?.wavBlob)); // 不能直接播放PCM
        // this.playAudio(
        //   "https://sharefs.ali.kugou.com/202310171635/69e095908b3eb36315a4b1d2674716f2/v3/132f1f09+
        //   d27556e952db597b54759dfd/yp/full/a1000_u0_p409_mx317723558_s3892550744.mp3"
        // );
        // this.playVideo('','baiduASR');

        const res = await baiduASRApi(this.vuex_baidu_asr_token, PCMBlob,true);// this.vuex_app_user_info?.phone === '18682128689' ? true :

        const resultText = res?.result?.[0];
        if (!resultText) {
          this.$myToast({
            type: "fail",
            message: "未识别到内容",
          });

          this.changeASRShow(true);
          this.changeASRText("未识别到内容",false, {'text': '识别到结果'});
          this.timeOutClearASRShow();

          this.$refs?.InputTool?.changeLoading?.(false);
          return false;
        }

        this.changeASRShow(true);
        this.changeASRText(resultText, true, {'text': '识别到结果'});
        this.timeOutClearASRShow(async () => {
          try {
            // this.aliyunTTS();
            this.$refs?.InputTool?.changeLoading?.(false);
            console.log('发送语音识别结果：' + resultText + '.')

            await this.sendMsg(resultText, "语音识别结果", true);
            // noah modify 1219 改成让用户确认文字内容须点击发送 出发主动播放音频事件
            /* this.$refs?.InputTool.sendInputText(resultText)
            this.$refs?.InputTool.iconClick('input') */
          } catch (error) {
            console.error("🚀 ~ file: index.vue:282 ~ .then ~ error : ", error);
          }
        });
        return resultText;
      } catch (error) {
        console.error("🚀 ~ file: index.vue:288 ~ baiduASR ~ error : ", error);
        // this.$myToast?.clear?.();
        this.$refs?.InputTool?.changeLoading?.(false);
        this.$myToast({
          type: "fail",
          message: error?.err_msg || "语音识别错误",
        });
      }
    },
    async baiduASR_copy(PCMBlob) {
      if (!this.vuex_baidu_asr_token) {
        this.$myToast({
          type: "fail",
          message: "无 ASR Token",
        });
        return false;
      }
      if (!PCMBlob) {
        this.$myToast({
          type: "fail",
          message: "无音频数据",
        });
        return false;
      }

      try {
        this.$refs?.InputTool?.changeLoading?.(true);

        this.changeASRShow(true);
        this.changeASRText("识别中，请稍后...");

        // this.$myToast({
        //   type: "loading",
        //   message: "识别中",
        //   forbidClick: true,
        //   overlay: true,
        //   duration: 0,
        // });

        // this.playAudio(window.URL.createObjectURL(data?.wavBlob)); // 不能直接播放PCM
        // this.playAudio(
        //   "https://sharefs.ali.kugou.com/202310171635/69e095908b3eb36315a4b1d2674716f2/v3/132f1f09d27556e952db597b54759dfd/yp/full/a10 +
        //   00_u0_p409_mx317723558_s3892550744.mp3"
        // );
        // this.playVideo('','baiduASR');

        const res = await baiduASRApi(this.vuex_baidu_asr_token, PCMBlob,true) // this.vuex_app_user_info?.phone === '18682128689' ? true : false

        const resultText = res?.result?.[0];
        if (!resultText) {
          this.$myToast({
            type: "fail",
            message: "未识别到内容",
          });

          this.changeASRShow(true);
          this.changeASRText("未识别到内容");
          this.timeOutClearASRShow();

          this.$refs?.InputTool?.changeLoading?.(false);
          return false;
        }

        this.changeASRShow(true);
        this.changeASRText(resultText);
        this.timeOutClearASRShow(async () => {
          try {
            // this.aliyunTTS();
            this.$refs?.InputTool?.changeLoading?.(false);
            console.log('发送语音识别结果：' + resultText + '.')

            //await this.sendMsg(resultText, "语音识别结果", false);
            // noah modify 1219 改成让用户确认文字内容须点击发送 出发主动播放音频事件
            console.log('resultText', resultText)
            this.$refs?.InputTool.sendInputText(resultText)
            this.$refs?.InputTool.iconClick('input')
          } catch (error) {
            console.error("🚀 ~ file: index.vue:282 ~ .then ~ error : ", error);
          }
        });

        // this.$myDialog({
        //   title: "语音识别结果",
        //   message: resultText,
        //   showCancelButton: true,
        //   confirmButtonText: "确认",
        //   closeOnClickOverlay: true,
        // })
        //   .then(async (result) => {
        //     // this.$myUniSDK?.updateWeb?.();
        //     try {
        //       // this.aliyunTTS();
        //       await this.sendMsg(resultText, "语音识别结果", false);
        //     } catch (error) {
        //       console.error(
        //         `🚀 ~ file: index.vue:282 ~ .then ~ error : `,
        //         error
        //       );
        //     }
        //   })
        //   .catch((err) => {});

        // this.$myToast?.clear?.();
        // this.$refs?.InputTool?.changeLoading?.(false);
        return resultText;
      } catch (error) {
        console.error("🚀 ~ file: index.vue:288 ~ baiduASR ~ error : ", error);
        // this.$myToast?.clear?.();
        this.$refs?.InputTool?.changeLoading?.(false);
        this.$myToast({
          type: "fail",
          message: error?.err_msg || "语音识别错误",
        });
      }
    },
    // howler 方案 onmark 2
    async textAudioTTS(text, paramsObj, isArt) {
      // console.log('enter textAudioTTS ' + readTime())
      // priority 优先级。0：最高，立即播放的，如废话文学；1：正常提问的回答的；2：主动提问题的回答（12暂未区分）
      if (!this.vuex_aliyun_tts_token) {
        this.$myToast({
          type: "fail",
          message: "无 TTS Token",
        });
        return false;
      }
      if (!text || text === '') {// || text === '\n'
        console.error('textAudioTTS 但是无文本数据合成个鸡毛' + text + 'end')
        this.$myToast({
          type: "fail",
          message: "无文本数据",
        });
        return false;
      }

      /* noah modify 取消20240910 因为 新版minimax合成较长 弹框难看
      this.$myToast({
        type: "loading",
        message: "生成中",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      */

      try {
        const t = text || "你好";
        /* const url = await aLiYunTTSUrl(text || "未传入文本,这是测试内容");
        if (url, t) {
          this.playAudioAndroidNewManyAudio(url, t, priority)
        } */
       /*  if (priority !== 0) {

        } */

        // 新版TTS方案MINIMAX
        this.requestIndex = this.requestIndex + 1
        // console.log('T start request', this.requestIndex, readTime())
        /*
        this.requestList = await aLiYunTTSUrl_axios_array(t, this.requestIndex) // 音频接口新 合成接口 aLiYunTTSUrl_axios_promise
        // console.log('T finish request', readTime())
        // keyword：新逻辑TTS播放方案 TTS方案 TTS新方案 根据请求结果的数组来
        // 返回的是整体数组 当数组长度大于1 且 没有播放的情况下 index = 0 开始播首句 播放完成后判断index是否 index + 1
        console.log('请求的队列被返回一次 this.requestIndex:', this.requestIndex, this.requestList)
        if(this.requestList.length > 0 && this.requestList[0].url !== '') {
          // 播放首句
          console.log('请求的队列 被返回一次 且 已有数据 this.playAudioIndex ', this.playAudioIndex )
          if(Math.abs(this.playAudioIndex - this.requestList[0].index) < 2){ // === 改为绝对值
            // 执行播放
            console.log('播放顺序 正正到它了，如果当前没有声音播放 它就播', this.isAudioPlaying)
            if(!this.isAudioPlaying){
              this.playFirstAudio(this.requestList[0])
            }
            // 播放结束后 playAudioIndex + 1 判断是否继续播
          } else {
            console.log('*** 播放顺序 还不到它播放 首个index为：', this.requestList[0].index , this.playAudioIndex )
          }
        } else {
          console.log('*** 请求的队列 被返回一次 但是  requestList 为空 或者 url为空', this.requestList[0].url)
        } */


        // promise方案
        requestMiniMaxTts(t, this.requestIndex, paramsObj, isArt).then(requestList => {
            this.requestList = requestList
            // console.log('T finish request', readTime())
            // keyword：新逻辑TTS播放方案 TTS方案 TTS新方案 根据请求结果的数组来
            // 返回的是整体数组 当数组长度大于1 且 没有播放的情况下 index = 0 开始播首句 播放完成后判断index是否 index + 1
            // console.log('请求的队列被返回一次 this.requestIndex:', this.requestIndex, this.requestList)
            if(this.requestList.length > 0 && this.requestList[0].url !== '') {
              // 播放首句
              // console.log('请求的队列 被返回一次 且 已有数据 this.playAudioIndex ', this.playAudioIndex )
              if(Math.abs(this.playAudioIndex - this.requestList[0].index) < 2){ // === 改为绝对值
                // 执行播放
                // console.log('播放顺序 正正到它了，如果当前没有声音播放 它就播', this.isAudioPlaying)
                if(!this.isAudioPlaying){
                  if (this.playAudioIndex === 0 && this.requestList[0].isArt){
                    setTimeout(()=>{
                      // 废话文学（音频生成+400ms）播报
                      this.playFirstAudio(this.requestList[0])
                    }, 600)
                  } else {
                    this.playFirstAudio(this.requestList[0])
                  }
                }
                // 播放结束后 playAudioIndex + 1 判断是否继续播
              } else {
                // console.log('*** 播放顺序 还不到它播放 首个index为：', this.requestList[0].index , this.playAudioIndex )
              }
            } else {
              // console.log('*** 请求的队列 被返回一次 但是  requestList 为空 或者 url为空', this.requestList[0].url)
            }
          })
          .catch((error) => {
             console.log('requestMiniMaxTts error:', error)
            this.$myToast?.clear?.();
            this.$myToast({
              type: "fail",
              message:  error?.status_msg || "音频生成错误",
            })
          })


        return true
      } catch (error) {
        console.error("🚀 ~ file: index.vue:347 ~ aliyunTTS ~ error : ", error);
        this.$myToast?.clear?.();
        this.$myToast({
          type: "fail",
          message: "音频生成错误",
        });
      }
    },
    async greetAudioTTS(text, priority) {
      // priority 优先级。0：最高，立即播放的，如废话文学；1：正常提问的回答的；2：主动提问题的回答（12暂未区分）
      if (!this.vuex_aliyun_tts_token) {
        this.$myToast({
          type: "fail",
          message: "无 TTS Token",
        });
        return false;
      }
      if (!text || text === '') {// || text === '\n'
        console.error('textAudioTTS 但是无文本数据合成个鸡毛' + text + 'end')
        this.$myToast({
          type: "fail",
          message: "无文本数据",
        });
        return false;
      }

      this.$myToast({
        type: "loading",
        message: "生成中",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      try {
        const t = text || "你好";
        // const url = await aLiYunTTSUrl(text || "未传入文本,这是测试内容");

        const url = aLiYunTTSUrl(t);
        // console.log("textAudioTTS aLiYunTTSUrl " + url)
        if (url, t) {
          this.pushGreetAudio(url, t, priority)
        }
        this.$myToast?.clear?.();
        return true;
      } catch (error) {
        console.error("🚀 ~ file: index.vue:347 ~ aliyunTTS ~ error : ", error);
        this.$myToast?.clear?.();
        this.$myToast({
          type: "fail",
          message: "音频生成错误",
        });
      }
    },
    pushGreetAudio(url, t, priority){
      // console.log('this.answerIndex:', this.answerIndex)
      const nextAudioModel = {}

      nextAudioModel.text = t
      nextAudioModel.url = url
      nextAudioModel.priority = priority

      // test 20240325
      this.testAudioList.push(nextAudioModel)
      //console.log('this.audioPlayPool', this.audioPlayPool)
      // 播放列表还没满队列则直接放进去
      if (this.audioPlayPool.length < this.audioPoolMax){
        let nextAudio = eval('this.$refs.myAudio' + this.answerIndex)[0] || eval('this.$refs.myAudio' + this.answerIndex);
        //console.log('nextAudio:', nextAudio)
        console.log('nextAudio src text:', t)
        nextAudioModel.nextAudio = nextAudio

        // nextAudio.src = url
        nextAudio.volume = 1
        nextAudio.preload = 'auto'
        nextAudio.loop = false
        nextAudio.muted = false
        nextAudio.text = t

        if (this.testAudioList.length > 1){
          // console.log('testAudioList.length > 1 加入池')
          nextAudio.src = url
          nextAudio.load()
          this.audioPlayPool.push(nextAudioModel)
          this.originAudioList.push(nextAudioModel)
        } else {
          console.log('声音锁，加入池 首句进行处理')

          this?.$_changeMsg({ content: t})
          let vuex_app_user_info = this.$store.state?.vuex_app_user_info
          vuex_app_user_info.biography = t
          this.$vuex('vuex_app_user_info', vuex_app_user_info)

          this.audioPlayPool.push(nextAudioModel)
          this.originAudioList.push(nextAudioModel)
        }
      }

      // console.log('this.pushGreetAudio.length:', this.testAudioList)
      this.answerIndex = this.answerIndex + 1
    },

    // 播放队列首句的方案
    playFirstAudio(playInfo){
      console.log('playFirstAudio playInfo', playInfo)
      let nextAudio = eval('this.$refs.myAudio' + 0)[0] || eval('this.$refs.myAudio' + 0)

      nextAudio.volume = 1
      nextAudio.preload = 'auto'
      nextAudio.loop = false
      nextAudio.muted = false // noah测试混音改为了true
      nextAudio.autoplay = false
      nextAudio.text = playInfo.text

      nextAudio.src = playInfo.url
      nextAudio.load()


      this.isTakingEnd = false

      // 加入播放结束的监听
      nextAudio.addEventListener('ended', this.onFirstAudioEnded)

      const firstAudioDurationChange = (event) => {
        this.changeSendMsgLoading()
        this.isAudioPlaying = true

        const targetAudio = event.target
        console.log('将要朗读：' + readTime(), this.currentTTSText)
        targetAudio.removeEventListener('durationchange', firstAudioDurationChange);
        // targetAudio.removeEventListener('canplay', firstAudioDurationChange);
        targetAudio.play().then(() => {
          //console.log('***第一话播放开始');
        }).catch((error) => {
          console.error('播放出现异常:', error);
        });
      }

      if (this.$refs?.InputTool?.getRecorderStatus?.()) {
        this.focusMode()
        return
      }

      nextAudio.addEventListener('error', () => {
        // 音频加载或播放发生错误，可以进行错误处理
        console.log('首句音频加载或播放发生错误，可以进行错误处理：');
      });
      nextAudio.addEventListener('playing', this.onAudioPlayingListenEvent)

      // 时间改变法
      nextAudio.addEventListener('durationchange', firstAudioDurationChange)
      // nextAudio.addEventListener('canplay', firstAudioDurationChange)
    },
    playAudioAndroidNewManyAudio(url, t, priority, index){
      //console.log('this.answerIndex:', this.answerIndex)

      const nextAudioModel = {}

      nextAudioModel.text = t
      nextAudioModel.url = url
      nextAudioModel.priority = priority
      if(index){
        nextAudioModel.index =  nextAudioModel.index
      }

      // test 20240325
      this.testAudioList.push(nextAudioModel)
      //console.log('this.audioPlayPool', this.audioPlayPool)
      // 播放列表还没满队列则直接放进去
      if (this.audioPlayPool.length < this.audioPoolMax){
        let nextAudio = eval('this.$refs.myAudio' + this.answerIndex)[0] || eval('this.$refs.myAudio' + this.answerIndex);
        //console.log('nextAudio:', nextAudio)
        console.log('nextAudio src text:', t)
        nextAudioModel.nextAudio = nextAudio

        // nextAudio.src = url
        nextAudio.volume = 1
        nextAudio.preload = 'auto'
        nextAudio.loop = false
        nextAudio.muted = false // noah测试混音改为了true
        nextAudio.autoplay = false
        nextAudio.text = t
        if (this.testAudioList.length > 1){
          console.log('testAudioList.length > 1 加入池')
          nextAudio.src = url
          nextAudio.load()
          this.audioPlayPool.push(nextAudioModel)
          this.originAudioList.push(nextAudioModel)
        } else {
          // 首句进行处理

          // test 20240325

          /* const onAudioEnded = (event) => {
            // 监听播放完成，ended 事件不准确
            console.log('nextAudio onEnded,testAudioList length:' + this.testAudioList.length)
            console.log('******播放完成，剩余句子数量：'+ this.testAudioList.length)
            console.log('******audioPlayPool：', this.audioPlayPool)
            // 在需要的时候移除 ended 事件监听器
            // 获取当前的音频元素

            const currentAudio = event.target;
            // 在需要的时候移除 ended 事件监听器
            currentAudio.removeEventListener('ended', onAudioEnded);
            console.log('event target:', currentAudio)

            this.playAudioIndex = this.playAudioIndex + 1
            console.log('播放完成停止的 将下一个的playAudioIndex：'+ this.playAudioIndex)

            this.stopMedia("myVideo", "playVideo");
            this.stopMedia("myAudio" + (this.answerIndex % this.audioPoolMax), "audioEnded");

            // 当播放列表结束一个，预载新的url进去
            if (this.testAudioList.length > this.audioPoolMax + this.playAudioIndex - 1){
              console.log('enter 当播放列表结束一个，预载新的url进去,替换前', this.audioPlayPool)
              let newAudioModel = this.testAudioList[this.audioPoolMax + this.playAudioIndex - 1]
              console.log('替换数据为 this.testAudioList的' +  (this.audioPoolMax + this.playAudioIndex)  + '条：',newAudioModel)
              let newAudioModelSrc = newAudioModel.url
              let replaceAudioModel =  this.audioPlayPool[(this.playAudioIndex - 1) % this.audioPoolMax]
              console.log('替换播放列表数据的 的' +  ((this.playAudioIndex - 1) % this.audioPoolMax)  + '条：', replaceAudioModel)
              let replaceAudio = replaceAudioModel.nextAudio
              replaceAudio.src = newAudioModelSrc
              // replaceAudio.addEventListener("ended", onAudioEnded)

              replaceAudioModel.url = newAudioModelSrc
              replaceAudioModel.text = newAudioModel.text
              replaceAudioModel.nextAudio = replaceAudio

              this.audioPlayPool[(this.playAudioIndex - 1) % this.audioPoolMax] = replaceAudioModel
              console.log('当播放列表结束一个，预载新的url进去 new:', this.audioPlayPool)
            }

            if (this.playAudioIndex < this.testAudioList.length){
              // 下一个播放列表中的audio开始播放
              console.log('this.playAudioIndex % this.audioPoolMax:' , this.playAudioIndex % this.audioPoolMax)
              let okAudioModel = this.audioPlayPool[this.playAudioIndex % this.audioPoolMax]
              const okAudio = okAudioModel.nextAudio
              const okAudioText = okAudioModel.text
              console.log('okAudio:', okAudio)
              okAudio.addEventListener('playing', ()=>{
                console.log('nextAudio  on playing' + new Date() + okAudioText)
                this.currAudio = okAudio
                this.onAudioPlaying()
              })
              okAudio.addEventListener('ended', onAudioEnded)

              this.currAudio = okAudio // 赋予过去是为了其他操作的控制 noah modify 1216
              this.currentTTSText = okAudioText
              console.log('后面的句子将要朗读：' + this.currentTTSText)

              const playAudio = ()=>{
                console.log('enter const playVideo()')
                console.log('后面句子音频 on playAudio readyState:', this.judgeReadyState(okAudio.readyState));

                okAudio.play().catch(error=>{
                  console.log('play video error after:', error)
                  playAudio()
                })

              }
              playAudio()
            }
            else {
              const stop = () => {
                console.log('当前问题回答播放完毕 this.testAudioList.length == 0')
                this.stopMedia('myVideo', 'playVideo')
                this.stopMedia('myAudio' + (this.playAudioIndex % this.audioPoolMax), 'audioEnded')
                this.clearProductReading()

                this.isAudioPlaying = false
                // nextAudio = null
                this.clearAudioList()
                this.clearTTSList()

              }

              // 正在播放的话，点击停止播放，并清空待播放列表
              if (this.isAudioPlaying === true) {
                console.log(' 正在播放的话，点击停止播放，并清空待播放列表 in mark 1')
                stop()
                return
              }
              stop()
            }
          } */

          // 测试混音 加入条件 如果当前还有播放的 主动停止
          if(this.isAudioPlaying){
            try {
              this.currAudio.pause()
            }catch (error) {
              console.log('测试混音 加入条件 如果当前还有播放的 主动停止 错误', error)
            }
          }
          console.log('声音锁，加入池 首句进行处理')
          // noah 测试混音
          console.log('测试混音 首句播放声音列表打印：' )
          this.testAudioList.forEach(t=>{
            console.log('测试混音 首句播放声音列表打印：' + t.text )
          })

          this.audioPlayPool.push(nextAudioModel)
          this.originAudioList.push(nextAudioModel)

          const firstAudioCanPlay = (event) =>{
            // console.log('enter canplaythrough will paly() index:'+ this.answerIndex)
            console.log('首句onCanplay将要朗读时间：', readTime())
            console.log('首句onCanplay将要朗读内容：' , t)
            if( this.isAudioPlaying){
              console.log('测试混音 首句朗读时 还有内容为朗读状态 将强制为停止' )
              try {
                this.currAudio.pause()
              }catch (error) {
                console.log('测试混音 加入条件 如果当前还有播放的 主动停止 错误', error)
              }
            }
            this.changeSendMsgLoading()
            this.isAudioPlaying = true
            this.currentTTSText = t
            const targetAudio = event.target

            targetAudio.removeEventListener('canplay', firstAudioCanPlay); //noah test
            // 切换播放资源时，如果地址切换过来了，但是就是不播放声音，这时一定要加个延时
            targetAudio.play().then(() => {
              console.log('***第一话播放开始');
            }).catch((error) => {
              console.error('***第一话播放失败:', error);
            });
          }
          // 闭包函数工厂，用于创建带有额外参数的事件处理函数
          /* const createFirstAudioDurationChangeHandler = (newPriority) => {
            return (event) => {

              // 复制firstAudioDurationChange里面的逻辑
            };
          };

          // 调用函数工厂以创建事件处理函数
          const firstAudioDurationChange = createFirstAudioDurationChangeHandler(priority); */

          const firstAudioDurationChange = (event) =>{
            // console.log('enter canplaythrough will paly() index:'+ this.answerIndex)
            console.log('首个音频 on durationchange：' + new Date())
            this.changeSendMsgLoading()
            this.isAudioPlaying = true
            this.currentTTSText = t
            /* if (priority === 0){
              this.priorityLock = true
            } else {
              this.priorityLock = false
            } */

            const targetAudio = event.target
            console.log('首句将要朗读：' + readTime(), this.currentTTSText)
            // console.log('nextAudio src:', readTime(), decodeURIComponent(targetAudio.src))
            // targetAudio.muted = false
            targetAudio.removeEventListener('durationchange', firstAudioDurationChange); //noah test
            // 切换播放资源时，如果地址切换过来了，但是就是不播放声音，这时一定要加个延时
            targetAudio.play().then(() => {
              // console.log('***第一话播放开始');
            }).catch((error) => {
              // console.error('***第一话播放失败:', error);
            });

          }

          this.isTakingEnd = false
          const firstAudio = this.audioPlayPool[0].nextAudio
          firstAudio.addEventListener("ended", this.onAudioEnded)

          console.log('回复的首句开始处理')
          if (this.$refs?.InputTool?.getRecorderStatus?.()) {
            this.focusMode()
            return
          }

          firstAudio.addEventListener('error', () => {
            // 音频加载或播放发生错误，可以进行错误处理
            console.log('首句音频加载或播放发生错误，可以进行错误处理：');
          });
          firstAudio.addEventListener('playing', this.onAudioPlayingListenEvent)
          /* firstAudio.addEventListener('loadedmetadata', () => {
            console.log('首句音频加载完成 by loadedmetadata');
            console.log('readyState:', this.judgeReadyState(firstAudio.readyState));
          });  */ // noah modify 202404020

          /*  firstAudio.addEventListener('loadeddata', () => {
             console.log('首句开始加载元数据 loadeddata');
           }); */

          //canplaythrough canplay 部分机型如谦哥iphone13 无法监听到回调
          // 改为timeChange策略
          /* firstAudio.addEventListener("canplay", firstAudioCanPlay)
          firstAudio.addEventListener("canplaythrough", ()=>{
            console.log('************************第一句能播放')
          }) */

          // 时间改变法
          firstAudio.addEventListener('durationchange', firstAudioDurationChange)

          firstAudio.src = url
          /*
          // iphone11 无法正常监听结束事件的问题
          // firstAudio.addEventListener('webkitended', () => {
          //
          //   console.log('******** Audio ended webkitended');
          // });
          console.log('setInterval setInterval setInterval');
           this.checkInterval = setInterval(() => {
            console.log('****** message Audio', firstAudio.ended)
            if (firstAudio && firstAudio.ended) {
              // this.message = 'Audio ended';
              console.log('****** message Audio ended')
              this.onAudioEnded2()

              this.clearCheckInterval()
            }
          }, 100);

          setTimeout(()=>{
            if(this.checkInterval !== null){
              this.clearCheckInterval()
            }
          },3000) */


          firstAudio.load()

          /* setTimeout(()=>{
            firstAudio.play().then(() => {
              console.log('first audio播放开始');
            }).catch((error) => {
              console.error('first audio播放失败:', error);
            });
          },1000) */

          // test 20240325 end
        }

      }

      // console.log(this.logName, 'playAudioAndroidNewManyAudio this.testAudioList.length:', this.testAudioList.length)
      this.answerIndex = this.answerIndex + 1
    },
    clearCheckInterval() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }
    },
    async aliyunTTS(text) {
      if (!this.vuex_aliyun_tts_token) {
        this.$myToast({
          type: "fail",
          message: "无 TTS Token",
        });
        return false;
      }
      if (!text) {
        console.log('aliyunTTS无文本数据' + text +'end')
        this.$myToast({
          type: "fail",
          message: "无文本数据",
        });
        return false;
      }

      this.$myToast({
        type: "loading",
        message: "生成中",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      try {
        // this.playAudio(window.URL.createObjectURL(data?.wavBlob)); // 不能直接播放PCM
        // this.playAudio(
        //   "https://sharefs.ali.kugou.com/202310171635/69e095908b3eb36315a4b1d2674716f2/v3/13 +
        //   2f1f09d27556e952db597b54759dfd/yp/full/a1000_u0_p409_mx317723558_s3892550744.mp3"
        // );
        // this.playVideo('','aliyunTTS');
        // const res = await aLiYunTTSApi(
        //   this.vuex_aliyun_tts_token,
        //   text || "未传入文本,这是测试内容"
        // );
        // if (res) {
        //   const blob = new Blob([res], { type: "audio/mp3" }); // 构造一个blob对象来处理数据，并设置文件类型
        //   const url = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
        //   this.playAudio(url);
        // }

        const t = text || "你好";
        this.currentTTSText = t;

        // const url = await aLiYunTTSUrl(text || "未传入文本,这是测试内容");

        const url = await aLiYunTTSUrl(t); // 音频接口新


        console.log("aLiYunTTSUrl " + url)
        if (url) {
          this.playAudio(url);
        }

        this.$myToast?.clear?.();
        return true;
      } catch (error) {
        console.error("🚀 ~ file: index.vue:347 ~ aliyunTTS ~ error : ", error);
        this.$myToast?.clear?.();
        this.$myToast({
          type: "fail",
          message: "音频生成错误",
        });
      }
    },


    changeSendMsgLoading(data = false, name = "") {
      console.warn(
        `🚀 ~ file: index.vue:674 ~ changeSendMsgLoading ~ name : `,
        data,
        name
      );
      // 回复框和文本框的loading不同步
      // this.$refs?.InputTool?.changeLoading?.(data);
      this.$refs?.RobotReplyContainer?.changeLoading?.(data);
      this.sendMsgLoading = data;
    },
    // 收到答复
    async sendMsgAnswerShowAndPlayEvent(answer, name, textModel) {
      this.priorityLock = false

      if (!this.firstPlayed) {
        // 更新到prompt
        this.beautyTalk += answer
        let userInfo = this.$store.state?.vuex_app_user_info
        userInfo.biography = this.beautyTalk
        this.$vuex('vuex_app_user_info', userInfo)
        this.currentTTSText = '给您拜年啦'
      } else {
        // 这里得放，不然切换商品时不停
        // 一点发送就停止
        //! ! 这里不能停止，不然数据流每次往数组里加进来的时候就会中断
        // this.stopAllMedia('sendMsgAnswerShowAndPlayEvent');
        // console.log('收到回复 enter sendMsgAnswerShowAndPlayEvent(), ', name, textModel)
        if (this.timeCountFlag){
          let currTime = new Date().getTime()
          let abs = currTime - this.timeCountABS
          this.timeCountABS = currTime
          console.log(this.timeCountTag, 'start 收到回复:', abs, readTime())
        }
        // 一次访问累计点击产品超过3次，第三个产品内容播报完后触发
        /* if (name === 'commodityClick'){
          this.productClickCount++
        } */

        if (!answer) {
          console.error(
            "🚀 ~ file: index.vue:465 ~ sendMsgAnswerShowAndPlayEvent ~ 没有answer : ",
            answer,
            name
          );
          return Promise.reject({ msg: "缺少文本" });
        }

        // 拦截字符串 特殊字符串处理
        // answer = answer.replace(/\#/g,'')

        // tts语音放入一个集合
        // 第1次点击你好按钮后播放中，处于保护期
        /* if(this.firstPlayed && !this.firstPlayEnd){
          console.log('被拦截')
          return
        } */
        // 主动交互原逻辑
        if(this.helloBtnClick){
          console.log('因为helloBtnClick=true被拦截')
          return
        }

        // 确认是否语音输入中，进行拦截
        if (this.$refs?.InputTool?.getRecorderStatus?.()) {
          console.log('因为语音输入被拦截')
          this.focusMode()
          return;
        }

        if(typeof this.$refs.myProductDialog !== 'undefined'){
          console.log('产品视频状态:'  + this.$refs.myProductDialog.pdVideoIsPlaying())
          this.$refs.myProductDialog.setLoading(false)
          if (this.$refs.myProductDialog.pdVideoIsPlaying()){
            console.log('产品视频正在播放被拦截')
            // 再次中断问答流程 清空列表
            try {
              console.log('触发 controllerAbort()')
              controllerAbort();
            } catch (error) {
              console.error(
                `🚀 ~ file: index.vue:242 ~ videoClick ~ error : `,
                error
              );
            }
            this.clearAudioList()
            this.clearTTSList()
            return
          }
        }

        /* let index = answer.indexOf('qr_code');
        answer = index !== -1 ? answer.substring(0, index) : answer;
        answer = 截取前面的文本*/

        if (answer.includes('qr_code')){
          console.log('弹出群聊条件触发')
          this.showQRGroupDialog()
        } else if(answer.includes('focus_on')){
          console.log('点击关注条件触发')
          this.showCareLove()
        } else {
          answer = this.judgeWebUrl(answer)
          answer = this.filterPercentageSign(answer) // 替换百分比符号
          this.TTSList.push({ text: answer })

          /* if (this.TTSList.length == 1) {
            console.log(
              "🚀 ~ file: index.vue:544 ~ sendMsgAnswerShowAndPlayEvent ~ this.TTSList.length == 1 : 播放第一句"
            );
            // 先播放第一条
            this.sendMsgAnswerShowAndPlay(this.TTSList[0]?.text);
          } */
          // noah modify 改变逻辑 await noah modify
           this.textAudioTTS(answer, {speed: 1.0}, false)
        }
        return Promise.resolve();
      }
    },
    judgeWebUrl (text) {
      const urlRegex = /https?:\/\/(?:www\.)?[^\s/$.?#].[^\s]*/g;
      return text.replace(urlRegex, (url) => {
        return ``;
      });
    },
    filterPercentageSign (text) {
      return text.replace(/%/g, '个百分点')
    },
    async sendMsgAnswerShowAndPlayEventGreet(answer, name) {
      // console.log('接收到的流式打招呼数据：', answer, name)
      this.$myToast?.clear?.()
      this.TTSList.push({ text: answer })
      this.greetText = this.greetText + answer
      /* let vuex_app_user_info = this.$store.state?.vuex_app_user_info
      vuex_app_user_info.biography = this.currentTTSText
      this.$vuex('vuex_app_user_info', vuex_app_user_info) */

      // console.log(' this.greetText',  this.greetText)
      this.greetAudioTTS(answer)
      return Promise.resolve()
    },
    async sendMsgAnswerShowAndPlay(answer) {
      if (!answer) {
        this.$myToast({
          type: "fail",
          message: "没有文本",
        });
        return Promise.reject({ msg: "没有answer" });
      }
      // this.currentTTSText = answer;
      console.warn(
        `\n<<<<<<<<<<<<<<<<<<<<<<<<<< 新的语音播放由此开始 : ${new Date()}\n`
      );
      this.changeSendMsgLoading(true);
      // 避免先展示文本等很久后才出声音，尽量文本和声音同步出现
      // this.$refs?.RobotReplyContainer?.changeMsg?.({ content: answer });
      /* 答复的媒体反馈 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
      //  停止所以正在播放的媒体
      await this.stopAllMedia("sendMsgAnswerShowAndPlay");
      // 不用手动控制视频播放，直接用audio的事件
      try {
        console.log('answer ' + answer)
        await this.aliyunTTS(answer);

        // 声音播放后才结束加载
        // this.changeSendMsgLoading(false);
        return Promise.resolve(answer);
      } catch (error) {
        this.changeSendMsgLoading(false, "sendMsgAnswerShowAndPlay catch");
        this.$myToast({
          type: "fail",
          message: "语音合成失败",
        });
        return Promise.reject(error);
      }
      /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */
    },
    btnTestClick(){
      console.warn(`btnTestClick new`);
      setTimeout(() =>{
        this.cancelPromptTimer();
      },300)
      logRequestArray()
      controllerAbort2()
      // clearRequestArray()
      // clearRequestArray();
      const appid = 'wxff73aa48e85c36cc';// 微信公众号APPID
      const option = 'snsapi_userinfo'
      const redirect_uri = encodeURIComponent('https://h5.meuagi.com/pages/wx/redirect');// 网页授权code回调地址 https://h5.meuagi.com
      const env = isDt ? 'd' : 't'

      const additionalParams = {
        iy: this.$store.state.appletInfo.identity// 不管是开发携带各种参数 统一回调为H5的identity

        //native: this.$store.state.appletInfo.native
      };
      let stateParamsObj
      if(isDt){
        const envdt = 'dt'
        stateParamsObj = JSON.stringify({ ...additionalParams, envdt })
      } else {
        const envtest = 't'
        stateParamsObj = JSON.stringify({ ...additionalParams, envtest })
      }
      const stateParams = encodeURIComponent(stateParamsObj)

      // 解码打印 decodeURIComponent
      //https://dt.aigcpop.com/h5_130/#/?code=0219gu1w3nk6D337Dx1w30gvoZ09gu1H&state={"identity":"","native":"05e3a10fe5774ba880255db238192719","appName":"test"}

      console.log('encodeURIComponent',stateParamsObj, stateParams)

      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid +
        '&redirect_uri=' + redirect_uri +
        '&response_type=code' +
        '&scope=' + option +
        '&state=' + stateParams +
        '#wechat_redirect'
    },
    encodeMini(query){
      // 把对象转换成 a=1&b=2&c=3&d=4 的字符串格式
      let queryString = Object.keys(query).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`).join('&')
      // 对其进行转码
      let resEncode = encodeURIComponent(queryString)
      return resEncode
    },
    async promptMessage(text){
      try {
        // sendMsg方法中：1.停止正在播放的 2.清空声音池
        await this.sendMsg(text, 'promptMessage', true)
      } catch (error){
        console.log('promptMessage error:', error)
      }
    },
    adviceClick(isPlay){
      if (isPlay){
        this.adviceClickEnd = false
      } else {
        this.adviceClickEnd = true
        this.stopAllMedia('adviceClick')
      }
    },
    async sendMsg(text, name, textModel) {
      console.warn(`🚀 ~ index.vue:667 ~ sendMsg ~ text : `, text, name);
      if (this.timeCountFlag){
        this.timeCountABS = new Date().getTime()
        console.log(this.timeCountTag, 'start sendMsg time:', 0, readTime())
      }
      this.resetFirstData() // 应该为视频点击停止后 或 发送消息时清空

      if( name === 'sendMsgClick' || name === '语音识别结果') {
        console.log('will send changeQuestionMsg')
        this.$refs?.RobotReplyContainer?.changeQuestionMsg?.({ content: text });
        this.chatCount = this.chatCount + 1
      }

      return new Promise(async (resolve, reject) => {
        if (!text) {
          this.$myToast({
            type: "fail",
            message: "无文本数据",
          });
          return reject("无文本数据");
        }
        try {
          //! ! 一发送就清空，且不能放在stopAllMedia中清空
          this.clearTTSList();
          this.clearAudioList()

          try {
            console.log('输入框发送消息前触发 controllerAbort()' + readTime())
            // 停止响应回答
            controllerAbort()
            clearAllStr()
          } catch (error) {
            console.error(
              `🚀 ~ file: index.vue:242 focusMode ~  发送先停止主动提示的响应回答 ~ error : ` + readTime(),
              error
            );
          }

          // 一点发送就停止
          this.stopAllMedia("sendMsg"); // 放上来是能够停止视频和声音的状态

          // todo 发送先停止主动提示的响应回答
          // this.focusMode()

          /* controllerAbort()
          clearAllStr() */
        /*  setTimeout(()=>{
           this.clearTTSList();
           this.clearAudioList()
           // 一点发送就停止
           this.stopAllMedia("sendMsg"); // 放上来是能够停止视频和声音的状态 // noah测试混音 再次加上
         },100) */

          if (textModel){
            this.changeSendMsgLoading(true)
          } else {
            this.changeSendMsgLoading(false)
          }

          // 废话文学 但是 主动提示和产品咨询的不进行占用
          if (!name.includes('resultPrompt') && name !== 'promptMessage') {
            // 开启或取消废话文学

            // 如果判断为打招呼的内容
            const getRandomText = ()=>{
              let _lalaText = ''
              if(text.length < 4){
                if(text.includes('你好') || text.includes('您好') || text.includes('hi') || text.includes('嗨')
                  || text.includes('哈喽')|| text.includes('早上好')|| text.includes('中午好')|| text.includes('晚上好')){
                  _lalaText = this.randomNonsense()
                } else {
                  _lalaText = this.randomNonsense2()
                }
              } else {
                _lalaText = this.randomNonsense2()
              }
              return _lalaText
            }
            let lalaText = getRandomText()
            if (lalaText !== ''){
              this.priorityLock = true
              // this.resetFirstData()
              this.textAudioTTS(lalaText, { speed: 0.8 }, true) // 废话文学 await
            }
          } else {
            this.$refs?.RobotReplyContainer?.changeQuestionMsg?.({ content: '' });
          }

          // const res = await askApi(text);
          this.currentQuestion = text
          // let res
          // 区分开agent版本 在微信小程序中有效
          // 微信小程序下并且是主动聊天 才是agent，否则走老接口
          /* if(this.$store.state.weiXinMark && (name === 'sendMsgClick' || name === '语音识别结果')) {
            res = await askApiStreamAgent(text, textModel, name)
          } else {
            res = await askApiStream(text, textModel, name)
          } */
          // 先不上agent版本
          const res = await askApiStream(text, textModel, name)
          return resolve(res)
        } catch (error) {
          console.error(
            "🚀 ~ file: index.vue:2827 ~ return new promise ~ error : ",
            error
          )

        /*   this.clearTTSList();
          this.clearAudioList()

          // 一点发送就停止
          // this.stopAllMedia("sendMsg"); // noah modify 20240418 因为中断导致的废话文学也被中断

          this.changeSendMsgLoading(false, "取消加载效果因为发送消息异常或中断");
           */

          this.$myToast?.clear?.();
          if (!error?.noShowToast || error?.msg !== '小程序用户未登录') {
            this.$myToast({
              type: "fail",
              message: error?.msg || "服务待重试",
            });
          }

          return reject(error);
        }
      });
    },
    clickCounter() {
      this.globalClickCount++

      if(this.firstPlayed && this.needPrompt){
        this.startPromptTimer()
      }
    },
    showCareLove() {
      console.log('enter showCareLove')
      this.showCareLoveShowEnd = true
      if (this.$store.state?.vuex_app_user_info?.wechat_qr_code !== ''){
        // 播放固定语音 和显示关注弹窗
        this.resetFirstData() //  发送消息时清空
        this.textAudioTTS('点击关注，以后就可以随时在小程序里跟我互动啦。', {speed: 1.0},)
        setTimeout(()=>{
           this.showCareDialog = true
        },500)
      }
      // 取消播放固定语音 因为agent版本已经有回复且句号分隔符了
    },
    showLiuYan() {
      // 播放固定语音
      this.clearAudioList() // 不加的话 直观影响是留言声音没有播放 原因是声音池长度判断无法通过
      this.resetFirstData()
      this.sendMsgAnswerShowAndPlayEvent('“如果您还有其他需要了解的问题，也可以留下您的联系方式，后续我会联系您哦', '展示留言', true)

     setTimeout(()=>{
       this.showLiuYanEnd = true
       // this.$refs.userInfoCard.liuYanClick()
       this.$refs.myLinkInfoCard.liuYanClick()
     }, 500)
    },
    showQRGroupDialog(){
      // 一天内交互超过5次 且 用户已设置群二维码
      if (this.$store.state?.vuex_app_user_info?.wechat_qr_code !== ''){
        // 播放固定语音
        // 不加的话 直观影响是留言声音没有播放 原因是声音池长度判断无法通过
        this.clearAudioList()
        this.resetFirstData()
        this.sendMsgAnswerShowAndPlayEvent('我们的用户群里也会不定期推出优惠活动和上新消息哦，赶快扫描二维码进群交流吧。', '进群交流', true)
        this.$store.commit('updateShowQRCodeDialogEnd', true)

        setTimeout(()=>{
          // this.$refs.userInfoCard.groupChatClick()
          this.$refs.myLinkInfoCard.weiXinClick()
        },500)
        // 取消播放固定语音 因为agent版本已经有回复且句号分隔符了
      }
    },
    // 播放固定文本
    playTextAudio(text, name){
      this.stopAllMedia('播放固定文本')
      this.clearAudioList()
      setTimeout(()=>{
        this.sendMsgAnswerShowAndPlayEvent(text, name, true)
      },200)
    },
    switchToImage(index) {
      // 切换到图片展示
      console.log(' this.index', index)
      this.currentMediaIndex = (index + 1) % 3
      console.log(' this.currentMediaIndex',  this.currentMediaIndex)
      // 根据index展示对应的图片
    },
    playProductVideo() {
      // 播放视频
      this.$refs.videoPlayer.play();
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
    },
    handleTouchMove(event) {
      this.touchEndX = event.touches[0].clientX;
    },
    handleTouchEnd() {
      const diff = this.touchEndX - this.touchStartX
      if (this.touchEndX !== 0 && this.touchStartX !== 0){
        if (diff > 50) {
          this.showPreviousImage();
        } else if (diff < -50) {
          this.showNextImage();
        }
      }

    },
    showPreviousImage() {
      console.log('showPreviousImage')
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex--;
      } else {
        this.$toast('已经是第一项了')
      }
    },
    showNextImage() {
      console.log('showNextImage')
      if (this.currentMediaIndex < this.mediaList.length - 1) {
        this.currentMediaIndex++;
      } else {
        this.$toast('已经是最后一项了')
      }
    },
    showProductDialog(item) {
      console.log('index show dialog item', item)
      this.productItem = item
      this.mediaDialog = true
    },
    onProductVideoPlay(){
      this.videoClick('video')
      // this.currAudio.pause()
      // this.$refs.myVideo.pause()
      // this.showTalkVideo = false
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      if (item.name === '呼叫') {
        this.aLink(`tel:${this.phone}`)
      }
    },
    aLink(href = "") {
      console.log('enter aLink')
      // 创建隐藏<a>标签进行下载
      const tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = href;
      // tempLink.setAttribute("download", this.fileDialogData?.name);
      // if (typeof tempLink.download === "undefined") {
      //   tempLink.setAttribute("target", "_blank");
      // }
      document.body.appendChild(tempLink);
      tempLink.click();
      this.$nextTick(() => {
        document.body.removeChild(tempLink);
      });
    },
    detailUrl() {
      // 处理url的逻辑 微信小程序中关注和喜欢状态的读取
      const params = url_to_query() || {}
      let appletInfo = this.$store.state.appletInfo
      if (params?.user_token){
        this.user_token = params?.user_token
      } else {
        this.user_token = ''
      }
      if (params?.is_new){
        this.is_new = params?.is_new
      } else {
        this.is_new = ''
      }
      if (params?.code && params?.state){
        console.log('wx code:' + params.code)
        appletInfo.code =  params.code
        const _stateStr = params?.state
        const stateStr = decodeURIComponent(_stateStr)
        try {
          const stateObject = JSON.parse(stateStr)

          //https://dt.aigcpop.com/h5_130/#/?code=0219gu1w3nk6D337Dx1w30gvoZ09gu1H&state={"":"","native":"05e3a10fe5774ba880255db238192719","appName":"test"}
          if(stateObject?.identity){
            appletInfo.identity =  params.identity
          }
          if(stateObject?.native){
            appletInfo.native =  params.native
          }
        } catch (error){
          console.error("pares json stateStr error", error);
        }

      } else {
        console.log('wx code not')
      }

      if (params?.shop_token){
        appletInfo.shop_token =  params.shop_token
      }
      if (params?.follow_state){
        appletInfo.isCare = params.follow_state === '1'
      }
      appletInfo.wxPhone = params?.wx_phone || ''

      appletInfo.is_new =  this.is_new
      appletInfo.user_token =  this.user_token

      if (params?.shop_token){
        appletInfo.shop_token =  params.shop_token
      }

      // H5
      if(params?.identity) {
        appletInfo.identity =  params.identity
      }
      // 小程序 或 开发测试
      if(params?.native) {
        appletInfo.native =  params.native
      }

      // 逻辑1:加载完成后记录访问姓名和访问次数
      if (params?.user_name){
        this.visit_user_name = params?.user_name
        appletInfo.user_name = params?.user_name
      } else {
        // 新逻辑 前端生成用户名
        // 查找是否生成过用户名
        let visit_user_name_local = localStorage.getItem('visitUserName')
        if (visit_user_name_local === null) {
          this.visit_user_name = generateUserName.generateUserName() // 生成随机用户名
        } else {
          this.visit_user_name = visit_user_name_local
        }
        this.visit_user_name = decodeURIComponent(this.visit_user_name)
        console.log('this.visit_user_name', this.visit_user_name)
        this.$vuexLS('updateVisitUserName', this.visit_user_name)
        appletInfo.user_name = this.visit_user_name
      }
      console.log('final appletInfo:', appletInfo)
      this.$vuex('appletInfo', appletInfo)

      // 读取在localstorage中
      let visitInfo = localStorage.getItem('visitInfo')
      if (visitInfo === null) {

        // 处理visitInfo不存在的情况
        console.log('visitInfo 不存在')
        visitInfo = []
        let visitData = {}
        visitData.visit_user_name = this.visit_user_name
        visitData.visit_number = 1
        visitData.chatCount = 0
        visitInfo.push(visitData)
        this.visitInfo = visitInfo
      }
      else {
        // 存在记录则进行查找
        this.$vuex('appletInfo', appletInfo)
        // 处理visitInfo存在的情况
        try {
          visitInfo = JSON.parse(visitInfo)
          console.log('visitInfo 存在访问记录') // visitInfo
          // todo 定量清理内存中的数据避免过多
          const foundIndex = visitInfo.findIndex(item => item.visit_user_name === this.visit_user_name)

          if (foundIndex > -1) {
            let foundItem = visitInfo[foundIndex]
            console.log('找到的项foundItem：', foundItem)
            foundItem.visit_number = foundItem.visit_number + 1
            visitInfo[foundIndex] = foundItem
            this.visitInfo = visitInfo
          } else {
            console.log('未找到符合条件的项foundItem')
            let visitData = {}
            visitData.visit_user_name = this.visit_user_name
            visitData.visit_number = 1
            visitInfo.push(visitData)
            this.visitInfo = visitInfo
          }
        } catch (error){
          console.log('JSON.stringify(visitInfo) error:', error)
        }
      }
      // 放入持久存储
      localStorage.setItem('visitInfo', JSON.stringify(this.visitInfo))

      // 主动交互逻辑 开启定时器
      // 参数 新老用户is_new 访问次数 交互次数
      // 替换prompt 尝试主动触发声音
      // 逻辑1:加载完成后记录访问姓名和访问次数
      // 逻辑2:加载完成后记录是否交互(是否点击过你好按钮)
      // 3秒后判断是否交互 若无交互才继续执行
      if (params?.is_new ){ // noah modify 新版本不登录 所以取消 && params?.user_name
        this.needPrompt = true
       /*  setTimeout(()=> {
          this.markThree = true
          // this.judgeActivePrompt()
        }, 3000) */
      }
    },
    judgeAlert() {
      console.log('judgeAlert onceAlertCount', this.onceAlertCount)
      console.log('judgeAlert chatCount', this.chatCount)
      console.log('judgeAlert productClickCount', this.productClickCount)
      console.log('judgeAlert isCare', this.$store.state.appletInfo.isCare)

      if(this.chatCount > 5 && !this.onceAlertCount[0]){
        this.onceAlertCount[0] = true
        return 0
      }
      if(this.productClickCount > 3 && !this.onceAlertCount[1]){
        this.onceAlertCount[1] = true
        return 1
      }

      if(this.chatCount > 3 && !this.onceAlertCount[2] && !this.$store.state.appletInfo.isCare){
        return 2
      }
      return -1
    },
    async judgeActivePromptTimer() {
      // todo 存在混音逻辑 对打开产品dialog状态 先不进行定时
      if (this.mediaDialog) {
        return
      }
      if(this.testAudioList.length > 0 || this.requestList.length > 0){
        console.log("测试混音 judgeActivePromptTimer AudioList.length > 0 will return")
        return
      }
      /**
       * 前置条件：无交互
       * 主动交互触发条件：1.新用户，页面无交互超过3s  2.新用户一天内访问次数超过3次，页面无交互超过3s 3.老用户，页面无交互超过3s
       * 新用户，页面无交互超过3s: 以第一人称视角简要介绍一下你提供的服务和产品，不超过100字。
       * 新用户多次进入，页面无交互超过3s 以第一人称视角简短介绍一下你的产品和服务有什么特点，怎么查看？不超过100字。
       * 非新用户，页面无交互超过3s 以第一人称视角简单介绍一下最近有什么新品或者活动推荐？不超过100字。
       */
      let resultPromptName = 'resultPrompt_A'
      let resultPrompt = '热情地打招呼，并以第一人称视角简要介绍一下你提供的服务和产品，不超过200字。'
      if (this.is_new === '0'){
        // 老用户
        resultPrompt = '有一个老用户在打招呼后未进行进一步对话，请结合上下文以第一人称视角向他简单介绍一下' +
          '最近有什么新品或者活动推荐。如没有足够的信息，让用户点击左上角进群/留言/电话联系，获取新品和活动的一手消息，不超过200字。'
        resultPromptName = 'resultPrompt_C'
      } else {
        // 获取访问次数：
        let visitUserIndex = this.visitInfo.findIndex(t=> t.visit_user_name === this.visit_user_name)
        if (visitUserIndex > -1) {
          let visitNumber = this.visitInfo[visitUserIndex].visit_number
          if (visitNumber > 3){
            resultPrompt = '有一个新用户在打招呼后未进行进一步对话，请结合上下文以第一人称视角向他简要介绍一下你的产品和服务有什么独特卖点，询问他的具体需求。不超过200字'
            resultPromptName = 'resultPrompt_B'
          } else {
            resultPrompt = '有一个新用户在打招呼后未进行进一步对话，请结合上下文以第一人称视角向他简要介绍一下你的产品和服务，以建立信任和亲近感。不超过200字'
            resultPromptName = 'resultPrompt_A'
          }
        }
      }
      console.log('result prompt:', resultPrompt)
      // 替换默认prompt 并 尝试播放
      try{
        await this.sendMsg(resultPrompt, resultPromptName, false)
      } catch (error){
        console.log('judgeActivePromptTimer sendMsg error:', error)
        if (error.msg === '小程序用户未登录') {
          this.cancelPromptTimer()
        }
      }
    },
    startPromptTimer(){
      this.cancelPromptTimer()
     console.log('进入开始定时器 停止后再启动定时器')
       this.promptTimer = setTimeout(()=>{
        this.judgeActivePromptTimer()  // noah test
      }, 15 * 1000)

    },
    cancelPromptTimer(){
      // console.log('enter cancelPromptTimer')
      console.log('取消了定时器')
      if (this.promptTimer !== null){
        clearTimeout(this.promptTimer)
        this.promptTimer = null
      }
    },

    // 专注模式 意味着终端问询 停止所有声音 视频恢复到正常模式 停止产品视频播放 和产品咨询、
    // 当语音输入时
    // 当文字询问一个新的问题时
    focusMode(){
      console.log('enter focusMode()')
      // 当前声音停止播放
      this.currAudio?.pause?.()
      this.howlAudio?.pause?.()
      this.currentTTSText = ''

      // 停止响应回答
      try {
        console.log('输入框发送消息前触发 controllerAbort()')
        controllerAbort()
        clearAllStr()
      } catch (error) {
        console.error(
          `🚀 ~ file: index.vue:242 focusMode ~  发送先停止主动提示的响应回答 ~ error : `,
          error
        );
      }
    },
    async clickMyself() {
      if (!this.firstPlayed) {
        console.log('noah test enter clickMyself')
        this.$myToast({
          message: "请先点击下方的 “你好” 进行唤醒",
        });
        return;
      }
      // 停止多模态咨询动效
      this.clearProductReading();
      if (!this.adviceClickEnd){
        this.adviceClickEnd = true // 咨询按钮点击后结束对话，改变咨询按钮状态
      }
      try{
        await this.sendMsg('介绍一下自己的背景信息，突出自身优势和独特性，不超过80个字。','个人介绍',true)
      } catch (error){
        console.log('judgeActivePromptTimer sendMsg error:', error)
      }

    },
    async clickCompany() {
      if (!this.firstPlayed) {
        this.$myToast({
          message: "请先点击下方的 “你好” 进行唤醒",
        });
        return;
      }

      // 停止多模态咨询动效
      this.clearProductReading();
      if (!this.adviceClickEnd){
        this.adviceClickEnd = true // 咨询按钮点击后结束对话，改变咨询按钮状态
      }
      try{
        await this.sendMsg('介绍一下公司的背景信息，突出公司优势和实力，包含完整的主语，不超过80个字。','公司介绍',true) // promptMessage
      } catch (error){
        console.log('judgeActivePromptTimer sendMsg error:', error)
      }
    },
    handleTiktok() {
      if(!this.firstPlayed) {
        console.log('noah test enter handleTiktok')
        // this.$myToast({
        //   message: '请先点击下方的 “你好” 进行唤醒',
        // })
        this.videoClick('video')
      } else {
        if (!this.showTiktok){
          // 停止对话 和 定时 延时进入
          this.stopAllMedia('个人视频')
          this.cancelPromptTimer()
          // 取消点击事件监听
          document.removeEventListener('click', this.clickCounter);
          this.showTiktok = true
        }
      }

    },
    handleTiktokTouchMove() {
      if(!this.firstPlayed) {
        this.$myToast({
          message: '请先点击下方的 “你好” 进行唤醒',
        })
        return
      }

      const touch = event.touches[0]
      const distanceFromRight = document.documentElement.clientWidth - touch.clientX
      if (distanceFromRight > 50){
        if (!this.showTiktok){
          // 停止对话 和 定时 延时进入
          this.stopAllMedia('个人视频')
          this.cancelPromptTimer()
          // 取消点击事件监听
          document.removeEventListener('click', this.clickCounter);
          this.showTiktok = true
        }

      }
    },

    // 组件通信
    closeTikTok() {
     this.showTiktok = false
      // 重启定时
      document.addEventListener('click', this.clickCounter)
    },
    liuyanShow(isShow){
      this.onceAlertCount[1] = true
      this.$refs.myTopToolBar.onChangeLiuYanShow(isShow)
    },
    onShowCareDialog(isShow){
      // 打开一次关注弹窗
      console.log('enter onShowCareDialog')
      this.onceAlertCount[2] = true
    },
    closeCareDialog(isShow){
      this.showCareDialog = isShow
    },
    onclickCare(isShow){
      this.$refs.myTopToolBar.toggleCare(isShow)
    },
    qunLiaoShow(isShow){
      this.onceAlertCount[0] = true
      this.$refs.myTopToolBar.onChangeQunLiaoShow(isShow)
    },
    changePhoneShow(isShow){
      this.phoneShow = isShow
    },
    closeUserCard() {
      this.$refs.myTopToolBar.closePanel()
    },
    // 点击查看个人资料卡的回调
    changePanelShow(isShow){
      console.log('enter changePanelShow', isShow)
      if(!this.firstPlayed){
        this.$refs.InputTool.helloClick()
      }
      if (isShow){
        console.log('将展开个人资料面板，关闭购物车列表')
        this.$refs.InputTool.closeShoppingCar()
      }
      this.showPanel = isShow
    },
    wantClick() {
      if(!this.firstPlayed){
        this.$refs.InputTool.helloClick()
      }
    },
    testStopTimer(isStop) {
      /* document.removeEventListener('click', this.clickCounter)
      if(isStop){
        this.cancelPromptTimer()
      } else {
        this.startPromptTimer()
      } */
    },
    // 点击购物车的回调
    onClickShoppingCar(isShow){
      console.log('enter onClickShoppingCar', isShow)
      // 必须关闭个人资料卡
      if (isShow){
        console.log('将展开购物车列表，关闭个人资料面板')
        this.$refs.myTopToolBar.closePanel()
      }
      this.$refs.ProductList.clickShoppingCar(isShow)
    },
    onClickShopChoose(isShow) {
      // 已入驻商户 且 微信小程序下 商城入口进入店铺主页;
      // 否则展示全部商品列表
      console.log('noah shop vuex_app_user_info.mall_state ', this.$store.state.vuex_app_user_info.mall_state)
      console.log('noah shop .miniProgramMark ', this.$store.state.miniProgramMark)
      if (MEDIA_SHOW){
        this.$refs.ProductList.clickShoppingCar(isShow)
        return
      }
      // 如果是该数字分身所有者开通了商城 则肯定是跳到小程序的
      // 区别在于是否在微信小程序环境下直接跳页面 还是唤醒微信跳转
      // 什么样的情况下会跳转商品 点击商品轮播图的时候
      const originPhone = this.$store.state?.vuex_app_user_info?.phone || ''
      if (this.$store.state.vuex_app_user_info.mall_state === 3) {
        if (this.$store.state.miniProgramMark) {
          // 目前方案遍历商品寻找id，todo 后续直接取第一个 或 最后一个
          console.log('noah shop onClickShopChoose mall_shop_id', this.$store.state.mall_shop_id)
          if (this.$store.state.mall_shop_id !== ''){
            // 已入驻且在微信下则跳到商铺页面
            wx.miniProgram.navigateTo({
              url: '/package-shop/pages/shop-page/shop-page?shopId=' + this.$store.state.mall_shop_id + '&originPhone=' + originPhone
            })
          } else {
            // 已入驻 但是没有商铺id代表没有更新过商城产品 则展示知识库商品列表
            this.$refs.ProductList.clickShoppingCar(isShow)
          }
        } else {
          // 已入驻但网页中打开
          console.log('已入驻但网页中打开 this.$store.state.mall_shop_id' , this.$store.state.mall_shop_id)
          if (this.$store.state.mall_shop_id !== ''){
            // 有商铺id
            let paramsObj = {
              shopId: this.$store.state.mall_shop_id + '',
              phone: originPhone
            }
            console.log('jumpMiniProgram paramsObj', paramsObj)
            this.jumpMiniProgram(1, paramsObj)
          } else {
            // 入驻过，但没有商铺id代表没有更新过商城产品 则展示知识库商品列表
            this.$toast('该商家未上架任何商品')
            this.$refs.ProductList.clickShoppingCar(isShow)
          }
        }
      } else {
        this.$refs.ProductList.clickShoppingCar(isShow)
      }
    },
    onClickFirstProduct() {
      this.videoClick('video')
    },
    onCommodityClick() {
      this.chatCount = this.chatCount + 1
      this.productClickCount = this.productClickCount + 1
    },
    jumpMiniProgram(type, jsonObj) {
      // console.log('jumpMiniProgram', type, jsonObj)
      // type 0 对于的h5数字分身； 1 商铺 2 商品
      let queryData
      /* if (type === 0){
        queryData = {
          phone: data + ''
        }
      } else if (type === 1) {
        queryData = {
          shopId: data + ''
        }
      } else{
        queryData = {
          prodId: data + ''
        }
      } */
      let resEncode = this.encodeMini(jsonObj)
      // &query=your_query 正式版为release，体验版为trial，开发版为develop
      // pages/index/index 貌似只能index页面
      let scheme = 'weixin://dl/business/?' +
        'appid=' + APPLET_Id + '&' +
        'path=pages/homeDt/homeDt&' +
        'env_version=trial&'+
        'query=' + resEncode
      // let scheme = 'weixin://dl/business/?' +
      //   'appid=' + APPLET_Id + '&' +
      //   'path=pages/homeDt/homeDt&' +
      //   'env_version=release&'+
      //   'query=' + resEncode

      console.log('jump miniProgram scheme:', scheme)
      window.location.href = scheme
    },
    toggleContent(){
      this.showContent = !this.showContent
      if(!this.firstPlayed){
        this.$refs.InputTool.helloClick()
      }
    },
    onShopUrl(url){
      this.frameSrc = url
      this.openShop = true
    },
    confirmLoginMiniDialog() {
      this.$vuex('loginMiniDialog', false)
      console.log('this loginMiniDialog2', this.$store.state.loginMiniDialog)
      // 微信下跳转到登录页面
      try{
        if(this.phone !== ''){
          wx.miniProgram.navigateTo({
            url: '/pages/index/index?byHome=1&phone=' + this.phone
          })
        } else {
          wx.miniProgram.navigateTo({
            url: '/pages/index/index?byHome=1'
          })
        }

      }catch (error){
        console.log('跳转小程序登录页面错误：', error)
      }
    },
    cancelLoginMiniDialog() {
      this.$vuex('loginMiniDialog', false)
      console.log('this loginMiniDialog', this.$store.state.loginMiniDialog)
    },
    // 全局消息监听
    getPostMessage (objectData) {
      if (!objectData.data || !objectData.data.method || typeof objectData.data.method === 'undefined') {
        return
      }
      const fData = objectData.data
      console.log('Index.vue get postMessage data:', fData)
      if (fData.method === 'deviceOnline') {
        // const deviceImei = fData.deviceImei
      } else if(fData.method === 'closeShop') {
        this.openShop = false
      }

      // 发送方法
      /* window.postMessage({
        method: 'deviceOnline',
        deviceImei: deviceImei,
        roomId: roomId,
      }, '*') */
      // iframe 给父页面发送方法
      /* window.parent.postMessage({
        method: 'closeShop'
      }, '*') */
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  height: 100vh;
  width: 100%;
  // width: 100%;
  overflow: hidden;
  // font-size: 0; // 问题很多，千万不要
  user-select: none; // 禁用复制
  position: fixed;
  top: 0;
  left: 0;
}
.poster-image {
  position: absolute;
  /*position: relative;
  z-index: 1;*/
  // transform: translateY(-100%);// 元素将向上移动自身的高度，即完全隐藏在其父元素的顶部之外。
  user-select: none;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.poster-image2 {
  width: 100%;
  height: calc(100vh - 64px);
  position: relative;
  z-index: 1;
  // transform: translateY(-100%);// 元素将向上移动自身的高度，即完全隐藏在其父元素的顶部之外。
  user-select: none;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.myCanvas{
  width: 100%;
  height: calc(25vh - 32px);
  position: relative;
  z-index: 1;
  // transform: translateY(-100%);// 元素将向上移动自身的高度，即完全隐藏在其父元素的顶部之外。
  user-select: none;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.main-video {
  // width: 100vw;
  width: 100%;
  // min-width: 100vw;
  min-height: calc(100vh - 64px);
  height: calc(100vh - 64px);
  margin: 0;
  padding: 0;
  border: none;
  z-index: 1;
  object-fit: cover;
  // clip-path: polygon(0 0, 100% 0%, 100% 65%, 0% 65%);

}
.main-video-fang {
  position: fixed;
 /* min-height: calc(100vh - 64px);
  height: calc(100vh - 64px);*/

  width: 100vw; //测试半屏

  margin: 0;
  padding: 0;
  border: none;
  z-index: 1;
 /* top: calc(50% - 64px);
  left: 50%;*/
  top: 0;
  left: 50%;
  // transform: translate(-50%, calc(-50% - 64px)); /* 将视频中心定位到容器中心 -50%  -50% */
  transform: translate(-50%, 0);
}
.shop_iframe{
  width: 100%;
  height: 100vh;
  z-index: 4999;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  border: none;
  object-fit: cover;
}
.videoTest{
  transform: translateZ(0);
}
/* This used to work for the parent element of button divs */
/* But it does not work with newer browsers, the below doesn't hide the play button parent div */


.main-video::-webkit-media-controls-panel {
  display: none !important;
  -webkit-appearance: none;
}

/* Old shadow dom for play button */

.main-video::-webkit-media-controls-play-button {
  display: none !important;
  -webkit-appearance: none;
}

/* New shadow dom for play button */

/* This one works! */

.main-video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

.IIV::-webkit-media-controls-play-button,
.IIV::-webkit-media-controls-start-playback-button,
.main-video::-webkit-media-controls-play-button,
.main-video::-webkit-media-controls-start-playback-button {
  opacity: 0;
  pointer-events: none;
  width: 5px;
}

.main-audio {
  position: absolute;
  width: 10em; // 防止滚动条
  height: 1em; // 防止滚动条
  top: 0;
  left: 0;
  z-index: -10; // 防止滚动条
  opacity: 0; // 苹果还是能看到 所以要全透明
  overflow: hidden;
}
//.bottom-tool-container {
//  position: fixed;
//  left: 0;
//  bottom: 0;
//  width: 100vw;
//  color: #fff;
//  z-index: 5;
//  //max-width: 100%;
//  //max-width: var(--app-max-width);
//  max-width: 992px;
//  max-width: var(--app-max-width);
//  // transform: translateX(-50%); // 加了会影响遮罩
//}
.bottom-tool-container {
  position: fixed;
  left: 50%;
  bottom: 0;
  width: 100vw;
  color: #fff;
  z-index: 9; // 会导致电话底部弹出sheet不限制前置界面
  //max-width: 100%;
  //max-width: var(--app-max-width);
  // max-width: 992px;
  max-width: var(--app-max-width);
  transform: translateX(-50%); // 加了会影响遮罩
  //安全区域
  padding-top: env(safe-area-inset-top);
  // padding-bottom: env(safe-area-inset-bottom); // 取消是为了就拉伸到底部 进行覆盖
}
.bottom-tool-main {
  margin: auto;
  max-width: 100%;
  // max-width: var(--app-max-width);
  color: #fff;
}
.cover-container {
  padding: 8px 16px;
  padding-top: 0;
}
.container-item {
  margin-top: 6px;
  padding: 4px 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  .loading-gif {
    height: 60px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background: transparent;

    margin: 0;
    padding: 0;
    // margin-bottom: -1px;
    // background-image: url("https://img01.yzcdn.cn/vant/apple-3.jpg");
  }
}

.abs_myself{
  position: absolute;
  width: 48px;
  height: 48px;
  right: 12px;
  top: 160px;
  z-index: 49;
}
.abs_company{
  position: absolute;
  width: 48px;
  height: 48px;
  right: 12px;
  top: 220px;
  z-index: 49;
}
.abs_company_text{
  position: absolute;
  width: 14px;
  right: 32px;
  top: 80px;
  z-index: 49;
  writing-mode: vertical-lr;/*文字竖向*/
  /*-webkit-text-stroke: 0.2px #9a9ca0; !* 字体描边效果，1px 为描边宽度，black 为描边颜色 *!
  text-stroke: 0.2px #9a9ca0; !* 字体标准语法 *!*/

  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}
.abs_zhiwei_text{
  position: absolute;
  width: 14px;
  right: 58px;
  top: 80px;
  z-index: 49;
  writing-mode: vertical-lr;/*文字竖向*/
 /* -webkit-text-stroke: 0.2px #9a9ca0; !* 字体描边效果，1px 为描边宽度，black 为描边颜色 *!
  text-stroke: 0.2px #9a9ca0; !* 字体标准语法 *!*/

  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}
.abs_tiktok{
  position: absolute;
  width: 50px;
  height: 335px;
  text-align: right;
  right: 0;
  top: calc(50vh - 168px);
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
// 大于450宽度的大屏/网页端
//@media (min-width: 451px) {
//  .custom-media-dialog-width {
//    width: var(--app-max-width);
//  }
//}
</style>
<style lang="less">
.my_user_info_popup{
  background: rgb(37, 37, 37) !important;
  padding: 12px 16px 16px 16px;
  border-radius: 12px;
  max-width: var(--app-max-width);
  width: 100%;
  top: 14px !important;
  left: auto !important;
  box-sizing: border-box;
  .user_card_container{
    width: auto !important;
  }
}
</style>
